import React, { Component, useState, useEffect } from 'react';
import Page from '../components/Page';
import { Link, NavLink } from 'react-router-dom';
import { Button, Icon, Segment, Modal, Header, Image, Progress, Responsive, Embed, Popup, Dropdown, Form, Input, Label, Divider } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { toWapi, get, post } from '../util/api';
import _ from 'lodash';
import moment from 'moment';
import * as Sentry from '@sentry/browser';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CircularProgress from '@mui/material/CircularProgress';
import {
	Box,
	Paper,
	Grid,
	Alert,
	List,
	ListItem,
	TextField,
	Select,
	InputLabel,
	MenuItem,
	FormControl,
	Typography,
	Popover,
	Snackbar,
	Tooltip,
} from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import Linkk from '@mui/material/Link';
import axios from 'axios';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import * as GA from '../util/GA';
import Checkbox from '@mui/material/Checkbox';
import { QRCodeCanvas } from 'qrcode.react';
import PhoneSubscriptionUpdateModal from '../components/PhoneSubscriptionUpdateModal';
import { load_product } from '../actions/product.actions'; // Bu satırı ekleyin

const PHONE_PLAN_ID = process.env.REACT_APP_PHONE_PLAN_ID;
const MULTI_PHONE_PLAN_ID = process.env.REACT_APP_MULTI_PHONE_PLAN_ID;

const NEW_PHONE_PLAN_ID = process.env.REACT_APP_PHONE_NEW_PLAN_ID;
const PHONE_19_PLAN_ID = process.env.REACT_APP_PHONE_19_PLAN_ID;
const PHONE_15_PLAN_ID = process.env.REACT_APP_PHONE_15_PLAN_ID;
const PHONE_PLAN_ID_ANNUALLY = process.env.REACT_APP_YEARLY_PHONE;

var refresh_time = 5000;

// eslint-disable-next-line
import styled from '@emotion/styled';
const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	...theme.typography.body2,
	boxShadow: 'rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px',
	padding: theme.spacing(1),
	textAlign: 'center',
	alignItems: 'center',
	color: theme.palette.text.secondary,
}));

const searchMethod = ['number', 'id', 'name'];

/* const WhitePaper = styled(Paper)(({ theme }) => ({
	backgroundColor: 'white',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
	border: 'none',
	borderRadius: '0',
	boxShadow: 'none',
})); */

/* const ButtonItem = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	border: 'none',
	borderRadius: '0',
	boxShadow: 'none',
	...theme.typography.body2,
	textAlign: 'center',
})); */

function usePhoneState(phone, product) {
	const [state, setState] = useState({ id: phone && phone.id });
	refresh_time = 5000;
	useEffect(() => {
		if (!phone || !product) return;
		let timeout, removed;
		if (phone && phone.status == 'active') refresh_time = 20000;
		function update() {
			if (phone && phone.data && phone.data.sandbox) {
				setState({ id: phone && phone.id, replicas: 1, availableReplicas: 1, readyReplicas: 1 });
			} else {
				toWapi(`/api/${product.id}/${phone.id}/instance_status`, product.settings.wapi_token).then((response) => {
					if (!response || removed || response.status !== 200) return;

					let { success, status } = response.data;
					if (success) {
						let { replicas = 0, availableReplicas = 0, readyReplicas = 0 } = status;

						setState({ id: phone && phone.id, replicas, availableReplicas, readyReplicas });
						if (!readyReplicas) timeout = setTimeout(update, refresh_time);
					} else timeout = setTimeout(update, refresh_time);
				});
			}
		}
		timeout = setTimeout(update, refresh_time);
		return () => {
			removed = true;
			clearTimeout(timeout);
		};
	}, [phone, product]);
	return state;
}

function StatusBar(props) {
	const state = usePhoneState(props.phone, props.product);
	const [ready, setReady] = useState(props.image_loaded);
	//let times = props.first_time ? 3000 : 20000;
	useEffect(() => {
		const timer = setTimeout(() => {
			if (props.image_loaded) setReady(true);
		}, 3000);
		return () => clearTimeout(timer);
	}, [props.image_loaded]);
	if (!state || !props.phone || ready) return null;
	const { replicas, readyReplicas } = state;
	let label = 'loading state';
	let percent = 20;
	if (props.image_loaded) {
		percent = 100;

		label = 'ready';
	} else {
		if (replicas) {
			percent += 30;
			label = 'instance creating';
		}
		if (readyReplicas) {
			percent += 30;
			label = 'instance created';
		}
	}
	return (
		<Segment attached textAlign="center" style={{ padding: 0, overflow: 'hidden', borderBottom: 0 }}>
			<Progress className="phone-progress" size="small" percent={percent} indicating label={label} />
		</Segment>
	);
}
class PhonePreview extends React.Component {
	state = {
		error: null,
		errorInfo: null,
	};

	componentDidCatch(error, errorInfo) {
		this.setState({ error, errorInfo });
		Sentry.withScope((scope) => {
			scope.setExtras(errorInfo);
			const eventId = Sentry.captureException(error);
			this.setState({ eventId });
		});
	}

	render() {
		const { error } = this.state;
		const sp = this.props.selectedPhone;
		// Bawa (bawa) telefonun ekran görüntüsü yok → bağlıyken mock ekran üzerinde "Active" göster
		if (sp && sp.bawa && sp.status === 'active') {
			return (
				<Segment attached="bottom" textAlign="center" style={{ padding: 0, overflow: 'hidden', borderRadius: '0 0px 5px 5px' }}>
					<div style={{ position: 'relative', borderRadius: 4, overflow: 'hidden' }}>
						<img src="/mock_screen.png" alt="mock screen" style={{ width: '100%', display: 'block', opacity: 0.55 }} />
						<div
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								gap: 10,
							}}
						>
							<Icon name="check circle" size="huge" style={{ color: '#21ba45', margin: 0 }} />
							<div style={{ fontWeight: 'bold', fontSize: 18, color: '#fff', textShadow: '0 1px 4px rgba(0,0,0,0.7)' }}>
								WhatsApp Active
							</div>
						</div>
					</div>
					<div style={{ background: '#f6f6f6', padding: '10px 14px', fontSize: 12, color: '#555', lineHeight: 1.8 }}>
						<div>
							📱 ID: <strong>{sp.id}</strong>
						</div>
						{sp.number && (
							<div>
								<Icon name="phone" /> <strong>{sp.number}</strong>
							</div>
						)}
						<div>
							✅ Status: <strong style={{ color: '#21ba45' }}>Connected</strong>
						</div>
					</div>
				</Segment>
			);
		}
		if (error) {
			return (
				<Segment attached="bottom" textAlign="center" style={{ padding: 0, overflow: 'hidden', borderRadius: '0 0px 5px 5px' }}>
					<div>
						<Image
							fluid
							key={this.props.screen_ss}
							onLoad={this.props.imageOnLoad}
							src={this.props.selectedPhone.url + this.props.screen_ss}
							style={this.props.imageLoad ? {} : { width: 0, height: 0, visibility: 'hidden' }}
							alt=""
						/>
					</div>
				</Segment>
			);
		}
		return (
			<Box sx={{ width: '100%' }} attached="bottom" textAlign="center" style={{ padding: 0, overflow: 'hidden', borderRadius: '0 0px 5px 5px' }}>
				{this.props.selectedPhone ? (
					<div>
						<Image
							fluid
							key={this.props.screen_ss}
							onLoad={this.props.imageOnLoad}
							src={this.props.selectedPhone.url + this.props.screen_ss}
							style={this.props.imageLoad ? {} : { width: 0, height: 0, visibility: 'hidden' }}
							alt=""
						/>
						{!this.props.imageLoad && (
							<div
								style={{
									backgroundColor: '#eee',
									height: '540px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									fontSize: '24px',
									fontWeight: '100',
								}}
							>
								<span>
									<Icon loading name="spinner" /> Loading...
								</span>
							</div>
						)}
					</div>
				) : (
					<div
						style={{
							backgroundColor: '#eee',
							height: '540px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: '24px',
							fontWeight: '100',
						}}
					>
						Select a Phone
					</div>
				)}
			</Box>
		);
	}
}
async function takeQr(product, selectedPhone) {
	try {
		let result = await toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/qrData`, product.settings.wapi_token);
		return result && result.data;
	} catch (error) {
		return {};
	}
}

class QrPreview extends React.Component {
	state = { loaded: false };
	componentDidUpdate(prevProps) {
		// her tazelemede (yeni screen_ss) görseli tekrar yüklenene kadar loading göster
		if (prevProps.screen_ss !== this.props.screen_ss && this.state.loaded) this.setState({ loaded: false });
	}
	render() {
		let { selectedPhone, product, screen_ss } = this.props;
		// Bawa (bawa): qrData/QRCodeCanvas yerine /qrcode görseli (screen gibi direkt image döner)
		if (selectedPhone.bawa) {
			let qrUrl = `https://api.maytapi.com/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/qrcode?token=${product.settings.wapi_token}&time=${screen_ss || ''}`;
			let showImage = this.state.loaded && selectedPhone.status !== 'loading';
			return (
				<div
					style={{
						height: '540px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: '24px',
						fontWeight: '100',
					}}
				>
					{!showImage && <Icon loading name="spinner" size="big" />}
					{selectedPhone.status !== 'loading' && (
						<Image
							key={screen_ss}
							src={qrUrl}
							onLoad={() => this.setState({ loaded: true })}
							style={showImage ? { maxWidth: 320 } : { width: 0, height: 0, visibility: 'hidden' }}
							alt=""
						/>
					)}
				</div>
			);
		}
		let sss = selectedPhone.qr_string;
		return (
			<div
				style={{
					height: '540px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: '24px',
					fontWeight: '100',
				}}
			>
				{!sss || selectedPhone.status === 'loading' ? <Icon loading name="spinner" size="big" /> : <QRCodeCanvas size={240} value={sss} />}
			</div>
		);
	}
}

class Phones extends Component {
	phoneToDelete = null;

	state = {
		currentPhones: 0,
		totalPhones: 0,
		otherPhonesCount: 0,
		loading: true,
		imageLoad: false,
		imageOnceLoaded: false,
		phones: [],
		refreshBtn: false,
		selectedPhone: null,
		screen_ss: null,
		addBtnClickable: true,
		deleteBtnClicked: false,
		hoveredIndex: null,
		goToSubs: false,
		phoneLoading: false,
		openmodal: false,
		testnumber: '',
		testmessage: '',
		testphoneid: '',
		error: '',
		success: '',
		getCUrl: '',
		cpyCurl: 'Copy CURL',
		loadbtn: false,
		disabledbtn: true,
		statusmsg: '',
		playbtn: false,
		loadAddPhone: false,
		showDisabled: false,
		showingStatus: 'all',
		first_time: true,
		showCheckbox: false,
		showCheckEx: false,
		checkedPhones: [],
		checked: false,
		codeConnecting: false,
		showNotification: false,
		showIndiaNotification: false,
		showSouthAmericaNotification: false,
		getGeoLocation: {},
		proxyPopover: false,
		anchorEl: null,
		showingScreen: 'qrcode',
		boosterStatusMap: {},
		boosterCountDown: 5,
		boosterQrTs: null,
		boosterQrError: false,
		boosterActionLoading: null,
		creatingLoading: false,
		queues: [],
		queuesPhones: [],
		subscriptionUpdateModalOpen: false,
		messageOnScreen: null,
		messageColor: 'yellow',
		quickUpdateMode: false, // For adding just one phone without preview
		sandboxModalOpen: false,
		passkeyHelpModalOpen: false,
		enablingPasskeyExtension: false,
	};

	async componentDidMount() {
		let { product } = this.props;
		let pid = product.id;

		this.mount = true;

		let jsonFile = await fetch('https://maytapi.com/documentations/Maytapi_WhatsApp.postman_collection.json');
		let JsonFile = await jsonFile.json();
		this.setState({ JsonFile });
		toWapi(`/api/${product.settings.wapi_pid || pid}/listPhones`, product.settings.wapi_token)
			.then((data) => {
				if (!this.mount) return;
				if (data.status !== 200) {
					return;
				}
				let allPhones = _.orderBy(
					_.filter(data.data, function (it) {
						return it.type === 'whatsapp';
					}),
					'id'
				);

				/*
				for (let i = 0; i < data.length; i++) {
					data[i].order = i;
				} */

				// limit/count tüm telefonlara göre hesaplanır (secret + normal birlikte), ama listeler karıştırılmaz
				const onlySecret = !!this.props.secret;
				const isSecret = (it) => it.secret === true;
				// bu sayfada gösterilecek telefonlar (secret sayfasında secret:true, normal sayfada secret olmayanlar)
				let phones = _.filter(allPhones, (it) => (onlySecret ? isSecret(it) : !isSecret(it)));

				let filter_data = _.filter(allPhones, (it) => !it.data.sandbox);
				let currentPhones = filter_data.length; // tamamına göre
				let displayNonSandbox = _.filter(phones, (it) => !it.data.sandbox);
				let otherPhonesCount = filter_data.length - displayNonSandbox.length; // bu sayfada gösterilmeyen telefon sayısı
				let sandboxPhone = _.find(phones, (it) => it.data && it.data.sandbox);
				let totalPhones = currentPhones;
				let find = _.find(phones, { status: 'active' });
				if (find) {
					this.setState({ testphoneid: find.id, disabledbtn: false });
				} else if (!find && phones && phones[0]) {
					this.setState({
						testphoneid: phones[0].id,
						statusmsg: `Selected phone status is ${phones[0].id} If you want to send a message, you must activate the phone's status.`,
					});
				}
				//if (product.settings && product.settings.phone_limit) {
				totalPhones = product.settings.phone_limit;
				//}
				this.setState({
					loading: false,
					phones,
					phonesHolder: phones,
					currentPhones,
					totalPhones,
					otherPhonesCount,
					addBtnClickable: currentPhones < totalPhones,
					sandboxPhone,
				});
				if (phones && phones.length) {
					let first = phones[0];
					if (first.status !== 'disabled') {
						this.viewPhoneScreen(first.id, first.number, first.status, first.name, first.multi_device, first.data, false);
					}
				}
			})
			.catch((err) => {
				console.error(err);
				this.setState({ loading: false });
			});

		this._auto_timer = 0;

		this._auto_refresh = setInterval(() => {
			if (this.state && this.state.imageOnceLoaded && this.state.showingScreen === 'screen') {
				let _max = 20;
				if (
					this.state.selectedPhone &&
					(this.state.selectedPhone.status === 'loading' ||
						this.state.selectedPhone.status === 'qr-screen' ||
						this.state.selectedPhone.status === 'disabled' ||
						this.state.selectedPhone.status === undefined)
				)
					_max = 5;
				this._auto_timer++;
				if (this._auto_timer >= _max) {
					this.screenRefresh();
					this.updatePhoneAndImageWhenClicked(true);
				}
			}
		}, 1000);

		this._auto_refresh_qr = setInterval(() => {
			if (
				this.state.showingScreen === 'qrcode' &&
				this.state &&
				this.state.selectedPhone &&
				this.state.selectedPhone.status &&
				(this.state.selectedPhone.status === 'qr-screen' || this.state.selectedPhone.status === 'loading')
			) {
				let countDown = this.state.selectedPhone.countDown || 5;
				countDown--;
				let _selectedPhone = this.state.selectedPhone;
				_selectedPhone.countDown = countDown;
				this.setState({ selectedPhone: _selectedPhone });
				if (countDown < 1) {
					this.screenRefresh();
					this.updatePhoneAndImageWhenClicked(true);
				}
			}
			if (
				this.state.showingScreen === 'booster' &&
				this.state.selectedPhone &&
				this.state.boosterStatusMap[this.state.selectedPhone.id] === 'inactive'
			) {
				let boosterCountDown = this.state.boosterCountDown || 5;
				boosterCountDown--;
				this.setState({ boosterCountDown });
				if (boosterCountDown < 1) {
					this.setState({ boosterCountDown: 5 });
					this.fetchBoosterStatus(this.state.selectedPhone.id);
				}
			}
		}, 1000);

		//burada request atalaım
		let getGeoLocation = await get('/locationDetech/detech');
		if (getGeoLocation && getGeoLocation.success && getGeoLocation.location && getGeoLocation.location.country) {
			this.setState({ getGeoLocation: getGeoLocation.location, showNotification: true });

			const locationCountry = getGeoLocation.location.country;
			const indiaNeighboringCountries = ['IN', 'PK', 'CN', 'NP', 'BT', 'BD', 'MM', 'LK'];
			const colombiaAndEcuadorNeighboringCountries = ['EC', 'PE', 'BR', 'VE', 'PA', 'CO'];

			if (indiaNeighboringCountries.includes(locationCountry)) {
				this.setState({ showIndiaNotification: true });
			} else if (colombiaAndEcuadorNeighboringCountries.includes(locationCountry)) {
				this.setState({ showSouthAmericaNotification: true });
			}
		}

		await this.getQueues();
		if (this.state.queues && this.state.queues.length) {
			const filteredQueues = this.filterAndAddQueue(this.state.phones, this.state.queues);
			this.setState({ queuesPhones: filteredQueues });
		}
	}
	componentDidUpdate(prevProps, prevState) {
		if (
			this.state.showingScreen === 'booster' &&
			(prevState.showingScreen !== 'booster' || prevState.selectedPhone?.id !== this.state.selectedPhone?.id) &&
			this.state.selectedPhone
		) {
			this.fetchBoosterStatus(this.state.selectedPhone.id);
		}
	}

	componentWillUnmount() {
		this.mount = false;
		clearTimeout(this._sr);
		clearInterval(this._auto_refresh);
		clearInterval(this._auto_refresh_qr);
	}

	refreshSubscription = () => {
		// Reload product information to get updated subscription details
		setTimeout(() => {
			this.props.dispatch(load_product('maytapi'));
		}, 1000);
	};

	handleMessageUpdate = ({ message, color }) => {
		this.setState({
			messageOnScreen: message,
			messageColor: color,
		});
	};

	closeSubscriptionUpdateModal = () => {
		this.setState({ subscriptionUpdateModalOpen: false });
	};

	addNewPhone = async () => {
		let { product } = this.props;
		let pid = this.props.product.id;
		let phone_id = '';

		// If we can't add a new phone because we've hit the limit
		if (!this.state.addBtnClickable) {
			this.openAddModal();
			return;
		}

		this.setState({ historyDataMessage: true, loadAddPhone: true });

		let isPartner = product.settings && product.settings.partner;
		await toWapi(`/${isPartner ? 'partner' : 'api'}/${product.id}/addPhone`, product.settings.wapi_token, {})
			.then((data) => {
				if (data.status !== 200) {
					return;
				}
				data = data.data;

				if (data.success === false) {
					return;
				}
				let phones = this.state.phones;
				let newPhone = {
					id: data.id,
					number: data.number,
					name: data.name,
					multi_device: data.multi_device,
					status: 'creating...',
				};
				phone_id = data.id;
				phones.push(newPhone);
				this.setState({
					phones,
					currentPhones: phones.length + this.state.otherPhonesCount,
					addBtnClickable: this.state.totalPhones > phones.length + this.state.otherPhonesCount,
					loadAddPhone: false,
				});
				this.viewPhoneScreen(newPhone.id, newPhone.number, newPhone.status, newPhone.name, newPhone.multi_device, {}, true);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	delay = (ms) => new Promise((res) => setTimeout(res, ms));

	addSandBoxPhone = async () => {
		let { product } = this.props;
		this.setState({ historyDataMessage: true, loadAddPhone: true });
		let isPartner = product.settings && product.settings.partner;
		if (isPartner) return;
		await toWapi(`/api/${product.id}/addSandbox`, product.settings.wapi_token)
			.then((data) => {
				if (data.status !== 200) {
					return;
				}
				data = data.data;

				if (data.success === false) {
					return;
				}
				let _data = data.addedPhone;
				let phones = this.state.phones;
				let newPhone = {
					id: _data.id,
					number: _data.number,
					name: _data.name,
					multi_device: _data.multi_device,
					data: _data.data,
				};
				phones.push(newPhone);
				this.setState({ phones, addBtnClickable: this.state.totalPhones > phones.length + this.state.otherPhonesCount, sandboxPhone: newPhone });
				this.delay(5000).then(() => {
					setTimeout(() => {
						this.viewPhoneScreen(newPhone.id, newPhone.number, newPhone.status, newPhone.name, newPhone.multi_device, _data.data);
					}, 1000);
					this.setState({ loadAddPhone: false });
				});

				//this.viewPhoneScreen(newPhone.id, newPhone.number, newPhone.status, newPhone.name, newPhone.multi_device, _data.data);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	handleClickProxyButton = (event) => {
		if (!this.state.selectedPhone || !this.state.selectedPhone.data) {
			console.error('Selected phone or data is not available');
			return;
		}

		this.setState({
			proxyPopover: !this.state.proxyPopover,
			anchorEl: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			proxyPopover: false,
			anchorEl: null,
		});
	};

	deletebtn = () => {
		this.setState({ playbtn: true });
	};
	setName = () => {
		let { product } = this.props;
		let { selectedPhone, phones } = this.state;
		this.setState({ setnameloading: true });
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${this.state.selectedPhone.id}/setName`, product.settings.wapi_token, {
			name: this.state.phone_name,
		})
			.then((data) => {
				if (data.status !== 200) {
					return;
				}
				data = data.data;

				if (data.success === false) {
					return;
				}
				let index = _.findIndex(phones, function (it) {
					return it.id === selectedPhone.id;
				});
				phones[index].name = this.state.phone_name;
				this.setState({ phones });
			})
			.catch((err) => {
				console.error(err);
			});
	};

	screenRefresh = (full_refresh) => {
		this._auto_timer = 0;
		this.setState({ refreshBtn: true });
		this._sr = setTimeout(() => {
			this.setState({ refreshBtn: false });
		}, 3000);

		this.setState({
			screen_ss: new Date().getTime(),
			imageLoad: false,
			imageOnceLoaded: full_refresh ? false : this.state.imageOnceLoaded,
			proxyPopover: false,
		});
	};
	logoutPhone = (value) => {
		let selectedPhone = this.state.selectedPhone;
		let { product } = this.props;
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/logout`, product.settings.wapi_token).then((data) => {
			//console.log(data);
			let phone = _.find(this.state.phones, { id: selectedPhone.id });
			phone.status = 'loading';
			selectedPhone.status = 'loading';
			this.setState({ phones: this.state.phones, selectedPhone, logoutModal: false, showingScreen: 'qrcode' });
			if (data.data.success) {
				this.screenRefresh(true);
			} else {
				console.error(data.data);
			}
		});
	};
	reloadPhone = (value) => {
		let selectedPhone = this.state.selectedPhone;
		let { product } = this.props;
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/restart`, product.settings.wapi_token).then((data) => {
			if (data.data.success) {
				//console.log(data.data.success);
				this.screenRefresh(true);
			}
		});
	};

	redeployToSelected = async () => {
		this.setState({ redeployallmodal: false });
		const { product } = this.props;
		const { checkedPhones, phones } = this.state;
		// console.log('checkedPhones', checkedPhones);
		// console.log('this.state', this.state);
		let notDisabledPhones = _.filter(phones, (it) => it.type === 'whatsapp' && it.status !== 'disabled');
		//console.log('notDisabledPhones', notDisabledPhones);
		try {
			if (notDisabledPhones.length === checkedPhones.length) {
				const response = await toWapi(`/api/${product.settings.wapi_pid || product.id}//redeployAllPhones`, product.settings.wapi_token);
				//		console.log('response', response);
			} else {
				const response = await toWapi(`/api/${product.settings.wapi_pid || product.id}//redeployAllPhones`, product.settings.wapi_token, {
					phones: checkedPhones,
				});
				//		console.log('response', response);
			}

			this.setState({ checked: false, checkedPhones: [] });
		} catch (error) {
			console.error('redeployToSelected Error', error && error.message);
		}
	};

	redeployPhone = (value) => {
		let selectedPhone = this.state.selectedPhone;
		this.setState({ refreshBtn: true, openRedeploy: false });
		let { product } = this.props;
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/redeploy`, product.settings.wapi_token).then((data) => {
			if (data.data.success) {
				//console.log(data.data.success);
				this.screenRefresh(true);
			}
		});
	};

	connectWithPhoneNumber = () => {
		this.setState({ codeConnecting: true });
		let connectPhone = this.state.phoneNumber;
		let { product } = this.props;
		toWapi(
			`/api/${product.settings.wapi_pid || product.id}/${this.state.connectNumber}/connectWithPhoneNumber?number=${connectPhone}`,
			product.settings.wapi_token
		).then((data) => {
			if (data.data.success) {
				let _phones = this.state.phones;
				for (let i = 0; i < _phones.length; i++) {
					let phone = _phones[i];
					if (phone.id === this.state.connectNumber) {
						phone.connectionResult = data.data.connectionResult;
					}
				}
				this.setState({ phones: _phones, codeConnecting: false });
			}
		});
	};

	factoryResetPhone = () => {
		this.setState({ factoryresetmodal: false });
		let selectedPhone = this.state.selectedPhone;
		let { product } = this.props;
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/factoryreset`, product.settings.wapi_token).then((data) => {
			if (data.data.success) {
				//console.log(data.data.success);
				this.screenRefresh(true);
			}
		});
	};
	StuckClearPhone = () => {
		this.setState({ stuckmodal: false });
		let selectedPhone = this.state.selectedPhone;
		let { product } = this.props;
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/clear`, product.settings.wapi_token).then((data) => {
			if (data.data.success) {
				//console.log(data.data.success);
				this.screenRefresh(true);
			}
		});
	};
	imageOnLoad = () => {
		this.setState({ imageLoad: true, imageOnceLoaded: true });
	};

	updatePhoneAndImageWhenClicked = async (interval, isAddPhone) => {
		let selectedPhone = this.state.selectedPhone;
		let phone_id = selectedPhone.id;
		let { product } = this.props;
		if (isAddPhone) {
			selectedPhone.newphone = true;
			this.setState({ selectedPhone });
		}
		if (selectedPhone.status !== 'active') {
			if (selectedPhone.status === 'disabled') {
				console.log('disabled');
			} else
				await takeQr(product, selectedPhone).then((data) => {
					let qr_string = data && data.qrData;
					if (qr_string) {
						selectedPhone.qr_string = qr_string;
						if (phone_id === this.state.selectedPhone && this.state.selectedPhone.id) {
							this.setState({ selectedPhone });
						}
					}
					if (!interval && this.state.showingScreen !== 'booster') {
						this.setState({ showingScreen: 'qrcode' });
					}
				});
		}
		if (selectedPhone.status === 'creating...') {
			let _counter = 0;
			let success = false;
			this.setState({ creatingLoading: true });
			while (_counter < 5 && !success) {
				_counter++;
				await takeQr(product, selectedPhone)
					.then((data) => {
						let qr_string = data && data.qrData;
						if (qr_string) {
							selectedPhone.qr_string = qr_string;
							success = true;
							this.setState({ selectedPhone, creatingLoading: false });
							if (!interval && this.state.showingScreen !== 'booster') {
								this.setState({ showingScreen: 'qrcode' });
							}
						}
					})
					.catch((error) => {
						console.error('QR kod alınırken hata oluştu:', error);
					});

				// Bir sonraki deneme öncesinde 3 saniye bekle
				if (!success && _counter < 5) {
					await this.delay(3000);
				}
			}
		}
		await toWapi(`/api/${product.settings.wapi_pid || product.id}/${selectedPhone.id}/status`, product.settings.wapi_token)
			.then(async (data) => {
				if (!this.mount) return;
				data = data.data;
				if (data.success) {
					let updatedStatus = 'active';
					if (data.status.connRetry) updatedStatus = 'no internet';
					else if (data.status.isQr) updatedStatus = 'qr-screen';
					else if (data.status.loading) updatedStatus = 'loading';
					else if (data.status.message) updatedStatus = 'phone-error';
					else if (data.status.loggedIn) updatedStatus = 'active';
					else updatedStatus = 'other';
					let phone = _.find(this.state.phones, { id: selectedPhone.id });
					phone.status = updatedStatus;
					phone.number = data.number;
					phone.version = data.status.version;
					phone.own_multi_device = data.status.multidevice;
					phone.proxy = data.mobile_proxy;
					phone.proxyRegion = data.proxy_region;
					selectedPhone.status = updatedStatus;
					selectedPhone.proxyRegion = data.proxy_region;
					this.setState({ phones: this.state.phones });
					if (phone_id === this.state.selectedPhone.id) {
						this.setState({ selectedPhone });
						if (updatedStatus === 'active' && this.state.showingScreen !== 'booster') this.setState({ showingScreen: 'screen' });
						// Bawa'te bağlandığında /screen görsel dönmez → loading'i kapat, mock'u göster
						if (selectedPhone.bawa && updatedStatus === 'active') {
							this.setState({ imageLoad: true, imageOnceLoaded: true });
						}
					}
					//if (updatedStatus === 'qr-screen' || updatedStatus === 'loading') this.setState({ showingScreen: 'qrcode' });
				}
			})
			.catch((err) => {
				console.error(err);
			});
	};
	checkEnabled = (id, number, status, name, multi_device) => {
		let { product } = this.props;
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${id}/enable`, product.settings.wapi_token).then((data) => {
			if (data.data.success) {
				let phone = _.find(this.state.phones, { id });
				phone.status = 'loading';
				this.setState({ phones: this.state.phones });
				this.viewPhoneScreen(id, number, status, name, multi_device, phone.data, false);
			} else {
				this.setState({
					disabledModal: true,
					disabledModalMessage: data.data.message,
				});
			}
		});
	};

	fetchBoosterStatus = (phoneId) => {
		const { product } = this.props;
		const pid = product.settings.wapi_pid || product.id;
		const token = product.settings.wapi_token;
		this.setState((prev) => ({ boosterStatusMap: { ...prev.boosterStatusMap, [phoneId]: null }, boosterQrTs: new Date().getTime(), boosterQrError: false }));
		toWapi(`/api/${pid}/${phoneId}/ba_status`, token)
			.then((res) => {
				if (this.mount) {
					const data = res.data;
					const isActive =
						data &&
						data.success &&
						(data.status === 'active' || (data.status && data.status.loggedIn === true));
					const status = isActive ? 'active' : 'inactive';
					this.setState((prev) => ({ boosterStatusMap: { ...prev.boosterStatusMap, [phoneId]: status } }));
				}
			})
			.catch(() => {
				if (this.mount) {
					this.setState((prev) => ({ boosterStatusMap: { ...prev.boosterStatusMap, [phoneId]: 'inactive' } }));
				}
			});
	};

	callBoosterAction = (phoneId, action) => {
		const { product } = this.props;
		const pid = product.settings.wapi_pid || product.id;
		const token = product.settings.wapi_token;
		const delay = action === 'ba_logout' ? 4000 : 0;
		this.setState({ boosterActionLoading: action });
		toWapi(`/api/${pid}/${phoneId}/${action}`, token)
			.then(() => {
				if (this.mount) {
					setTimeout(() => {
						if (this.mount) {
							this.setState({ boosterActionLoading: null });
							this.fetchBoosterStatus(phoneId);
						}
					}, delay);
				}
			})
			.catch(() => {
				if (this.mount) {
					setTimeout(() => {
						if (this.mount) {
							this.setState({ boosterActionLoading: null });
							this.fetchBoosterStatus(phoneId);
						}
					}, delay);
				}
			});
	};

	viewPhoneScreen = (id, number, status, name, multi_device, data = {}, isAddPhone) => {
		let { product } = this.props;
		let proxy = data && data.mobile_proxy;
		let phoneRec = _.find(this.state.phones, { id });
		let bawa = !!(phoneRec && phoneRec.bawa);

		this.setState({
			selectedPhone: {
				id,
				number,
				status,
				multi_device,
				bawa,
				url: `https://api.maytapi.com/api/${product.id}/${id}/screen?token=${product.settings.wapi_token}&time=`,
				data: data || {},
				proxy,
			},
			phone_name: name,
			first_time: false,
			...(status && status !== 'active' ? { showingScreen: 'qrcode' } : {}),
		});

		this.screenRefresh(true);
		setTimeout(() => {
			this.updatePhoneAndImageWhenClicked(false, isAddPhone);
		}, 0);
	};

	deletePhone = (id, number, status) => {
		this.phoneToDelete = { id, number, status };
		this.setState({ selectedPhone: null, deleteBtnClicked: true });
	};

	closeDeleteButton = () => {
		this.setState({
			deleteBtnClicked: false,
			goToSubs: false,
			disabledModal: false,
			openRedeploy: false,
			factoryresetmodal: false,
			logoutModal: false,
			stuckmodal: false,
			opendocumentmodal: false,
			openeditmodal: false,
			redeployallmodal: false,
			openConnectWithPhoneNumber: false,
		});
	};

	handleDelete = () => {
		let phones = this.state.phones;
		let { product } = this.props;
		let newPhones = [];
		for (let i = 0; i < phones.length; i++) {
			let phone = phones[i];
			if (phone.id !== this.phoneToDelete.id) {
				newPhones.push(phone);
			}
		}

		this.setState({
			deleteBtnClicked: false,
			phones,
			currentPhones: phones.length + this.state.otherPhonesCount,
			addBtnClickable: this.state.totalPhones > phones.length + this.state.otherPhonesCount,
		});
		toWapi(`/api/${product.settings.wapi_pid || product.id}/${this.phoneToDelete.id}/delete`, product.settings.wapi_token, {})
			.then((data) => {
				//	console.log(data);
				window.location.reload();
			})
			.catch((err) => {
				console.log(err);
			});
	};
	openAddModal = () => {
		const { product } = this.props;

		// Phone aboneliği var mı kontrol et
		const hasPhoneSubscription =
			product.activeSubs &&
			product.activeSubs.some((sub) => {
				const planId = sub.data.subscription_plan_id;
				return (
					planId === PHONE_PLAN_ID ||
					planId === NEW_PHONE_PLAN_ID ||
					planId === PHONE_19_PLAN_ID ||
					planId === PHONE_15_PLAN_ID ||
					planId === MULTI_PHONE_PLAN_ID ||
					planId === PHONE_PLAN_ID_ANNUALLY
				);
			});

		// Eğer zaten bir phone aboneliği varsa, güncelleme modalını aç
		if (hasPhoneSubscription) {
			this.setState({
				subscriptionUpdateModalOpen: true,
				quickUpdateMode: true, // Sadece bir telefon ekle
			});
		} else {
			// Eğer phone aboneliği yoksa, abonelik sayfasına yönlendir
			this.setState({ goToSubs: true });
		}
	};
	clickCopy = () => {
		this.setState({ cpy: 'Copied' });
		setTimeout(() => {
			this.setState({ cpy: 'Copy Screen Url' });
		}, 2000);
	};

	clickCopyCurl = () => {
		this.setState({ cpyCurl: 'Copied' });
		setTimeout(() => {
			this.setState({ cpyCurl: 'Copy CURL' });
		}, 2000);
	};
	changePhoneMod = async (data) => {
		let { id, mod } = data;
		let { product } = this.props;

		await toWapi(`/partner/${product.id}/${id}/changeMod`, product.settings.wapi_token, { mod }).then((data) => {
			if (data.status !== 200) {
				return;
			}
			data = data.data;
			window.location.reload();
		});
	};

	handleSelectButtonClick = () => {
		this.setState((prevState) => ({
			showCheckbox: !prevState.showCheckbox,
			showCheckEx: false,
			checked: false,
			checkedPhones: [],
		}));
	};

	handleAllButtonClick = async () => {
		const phonesEx = this.state && this.state.phones;
		let ids = [];
		let checkedPhones = [];
		ids = _.filter(phonesEx, (it) => it.type === 'whatsapp' && it.status !== 'disabled');
		ids = _.map(ids, 'id');

		checkedPhones = ids;

		if (this.state.showingStatus === 'has-queue') {
			ids = this.state.queuesPhones;
			ids = _.map(ids, 'id');
			checkedPhones = ids;
		}

		const checkedState = {};
		ids.forEach((id) => {
			checkedState[id] = true;
		});

		this.setState((prevState) => ({
			showCheckEx: !prevState.showCheckEx,
			showCheckbox: false,
			checked: checkedState,
			checkedPhones: this.state.showCheckEx === true ? [] : checkedPhones,
		}));
	};

	handleClick = (id) => {
		this.setState(
			(prevState) => ({
				checked: {
					...prevState.checked,
					[id]: !prevState.checked[id],
				},
			}),
			() => {
				const selectedPhoneId = this.state.selectedPhone.id;
				if (this.state.checked[selectedPhoneId]) {
					if (!this.state.checkedPhones.includes(selectedPhoneId)) {
						this.setState((prevState) => ({
							checkedPhones: [...prevState.checkedPhones, selectedPhoneId],
						}));
					}
				} else {
					this.setState((prevState) => ({
						checkedPhones: prevState.checkedPhones.filter((phoneId) => phoneId !== selectedPhoneId),
					}));
				}
			}
		);
	};

	emptyMyFunction = (id) => {
		console.clear();
		let phone = _.find(this.state.phones, (it) => it.id === id);

		if (!phone) {
			return;
		}

		let __selectedPhone = {
			id: phone.id,
			number: phone.number,
			status: phone.status,
			multi_device: phone.multi_device,
			data: phone.data || {},
			url: `https://api.maytapi.com/api/${this.props.product.settings.wapi_pid || this.props.product.id}/${id}/screen?token=${
				this.props.product.settings.wapi_token
			}&time=`,
		};

		this.setState({
			openConnectWithPhoneNumber: true,
			connectNumber: id,
			selectedPhone: __selectedPhone,
		});
		// console.log('selectedPhoneId:', id);
	};

	handleCloseNotification = () => this.setState({ showNotification: false });

	// Passkey bypass: telefonu (gerekirse) Bawa'e çevir, sonra web.whatsapp.com'u yeni sekmede açıp
	// pid/token/phone_id'yi extension'a URL hash ile ilet. Kullanıcı QR + passkey ile giriş yapınca
	// extension session'ı çıkarıp setBrowserAuth'a yükler → API auth'u kaydeder + pod'u restart eder → QR'sız bağlanır.
	passkeyBypass = async (id, bawa) => {
		const { product } = this.props;
		const pid = product.settings.wapi_pid || product.id;
		const token = product.settings.wapi_token;
		try {
			if (!bawa) {
				const res = await toWapi(`/api/${pid}/${id}/convertToBawa`, token);
				if (!(res && res.data && res.data.success)) {
					alert('Convert to Bawa failed: ' + ((res && res.data && res.data.message) || 'unknown'));
					return;
				}
			}
		} catch (e) {
			alert('Convert to Bawa failed: ' + (e.message || e));
			return;
		}
		const payload = btoa(JSON.stringify({ pid, token, phone_id: id }));
		window.open('https://web.whatsapp.com/#maytapi=' + payload, '_blank');
	};

	// Passkey extension özelliğini product.settings'e ekler (use_passkey_extension: true) → manuel eklemeye gerek kalmaz.
	enablePasskeyExtension = async () => {
		this.setState({ enablingPasskeyExtension: true });
		try {
			let res = await post('/maytapi/enablePasskeyExtension', {});
			if (res && res.data && res.data.success) {
				// redux product'ı tazele ki key butonları görünsün
				this.props.dispatch(load_product('maytapi'));
			} else {
				alert('Failed to enable passkey extension: ' + ((res && res.data && res.data.message) || 'unknown'));
			}
		} catch (e) {
			alert('Failed to enable passkey extension: ' + (e.message || e));
		}
		this.setState({ enablingPasskeyExtension: false });
	};

	TableRow = (phonedata, index, deletedSubs, activeSubs) => {
		let number = phonedata.number;
		let id = phonedata.id;
		let status = phonedata.status;
		let name = phonedata.name;
		let multi_device = phonedata.multi_device;
		let own_multi_device = phonedata.own_multi_device;
		let is_sandbox = phonedata && phonedata.data && phonedata.data.sandbox === true;
		let bawa = !!(phonedata && phonedata.bawa);
		let data = phonedata.data;
		let icon, textColor;
		let queue = phonedata && phonedata.queue;
		let allow_trial_mod_change = this.props.product.settings && this.props.product.settings.partner && this.props.product.settings.allow_trial_mod_change;
		/* console.log(
			'activeSubs',
			id,
			activeSubs,
			_.find(activeSubs, (it) => it.data.phone_id === '' + id)
		); */
		let phone_mod =
			status === 'disabled'
				? 'closed'
				: _.find(deletedSubs, (it) => it.data.phone_id === '' + id)
				? 'closed'
				: _.find(activeSubs, (it) => it.data.phone_id === '' + id)
				? _.find(activeSubs, (it) => it.data.phone_id === '' + id).data.status
				: id < 37657
				? 'live'
				: 'trial';
		let { product } = this.props;
		switch (status) {
			case 'active':
				icon = 'check';
				textColor = 'green';
				break;
			case 'qr-screen':
				icon = 'qrcode';
				textColor = 'orange';
				break;
			case 'loading':
				icon = 'clock';
				textColor = 'orange';
				break;
			case 'conn-retry':
				status = 'no internet';
				icon = 'wifi';
				textColor = 'red';
				break;
			case 'TIMEOUT':
			case 'PAIRING':
				icon = 'close';
				textColor = 'orange';
				break;
			case 'phone-error':
				icon = 'close';
				textColor = 'red';
				break;
			case 'low-battery':
				icon = 'battery zero';
				textColor = 'orange';
				break;
			case 'idle':
				icon = 'clock';
				textColor = 'grey';
				break;
			case 'disabled':
				icon = 'dont';
				textColor = 'grey';
				break;
			default:
				//status = 'no calls';
				icon = 'question circle';
				textColor = 'blue';
				break;
		}
		return (
			<ListItem
				sx={{
					display: 'block',
					cursor: 'pointer',
					padding: '4px 8px',
				}}
				key={index}
			>
				<Item
					id="item-phones"
					style={{
						textAlign: 'left',
						padding: '0',
						background: this.state.selectedPhone && this.state.selectedPhone.id === id ? 'rgba(174, 174, 174, 0.22)' : 'white',

						boxShadow: 'rgb(0 0 0 / 24%) 1px 1px 3px 0px',
					}}
				>
					<Grid
						container
						sx={{
							alignItems: 'center',
							color: 'black',
							'&:hover': {
								backgroundColor: 'rgba(207, 207, 207, 0.20)',
								borderRadius: '8px',
							},
						}}
					>
						<Grid
							item
							xs={8}
							sx={{ padding: '8px', display: 'flex', alignItems: 'center' }}
							onClick={() => {
								status === 'disabled'
									? !product.settings.partner
										? this.checkEnabled(id, number, status, name, multi_device)
										: null
									: this.viewPhoneScreen(id, number, status, name, multi_device, data);
							}}
						>
							{/* <ButtonItem
								className="phone-line"
								style={{
									display: 'inline',
									margin: '0 5px 0 5px',
									background: 'none',
								}}
							> */}
							{/* {multi_device && (
								<div className="multi-device" style={{ display: 'inline', margin: '0 5px 0 5px' }}>
									{
										<Popup
											content="Multi-Device"
											basic
											trigger={<Image style={{ display: 'inline', margin: '0 5px 0 5px' }} src="/multi-device.svg"></Image>}
										/>
									}
								</div>
							)}
							{own_multi_device && !multi_device && (
								<div style={{ display: 'inline', margin: '0 5px 0 5px' }} className="multi-device">
									<Popup
										content="Does not support multidevice. Please contact us about multi-device supported instances. If this instance redeploy, phone will disconnect."
										basic
										trigger={<Icon name="dont" color="red"></Icon>}
									/>
								</div>
							)} */}
							<div style={{ display: 'flex', alignItems: 'center' }} className="phone-id">
								{(this.state.showCheckbox || this.state.showCheckEx) && (
									<Checkbox
										sx={{ width: '30px', height: '30px' }}
										checked={this.state.checked[id] || false}
										onClick={() => this.handleClick(id)}
										inputProps={{ 'aria-label': 'controlled' }}
									/>
								)}
								<strong>id: {id}</strong>
							</div>
							<Responsive
								as="div"
								style={{ display: 'inline', margin: '0 5px 0 5px' }}
								className="phone-number"
								minWidth={Responsive.onlyMobile.maxWidth - 1}
							>
								<Icon name="phone"></Icon> {number || 'New Phone'} {name && '(' + name + ')'}
							</Responsive>
							<div style={{ display: 'inline', color: textColor, margin: '0 5px 0 5px' }} className="phone-status">
								<Icon name={icon}></Icon>
								{status}
							</div>
							{queue && (
								<div style={{ display: 'inline', margin: '0 5px 0 5px' }} className="phone-status">
									<strong>Queue: {queue}</strong>
								</div>
							)}

							{is_sandbox && <Label color="orange">Sandbox</Label>}
							{/* {data && (data.customProxy || data.mobile_proxy || data.appProxyEnabled) && (
								<Popup
									content={
										data.customProxy
											? 'BYOP proxy active — click to manage'
											: data.mobile_proxy
											? 'Managed proxy active — click to manage'
											: 'App proxy active — click to manage'
									}
									position="bottom right"
									trigger={
										<Link to={`/phone-proxy/${id}`} style={{ marginLeft: '5px' }}>
											<Icon name="shield" color="grey" style={{ cursor: 'pointer' }} />
										</Link>
									}
								/>
							)} */}
							{/* </ButtonItem> */}
						</Grid>
						{product.settings.partner ? (
							<div style={{ display: 'flex', marginLeft: 'auto', marginRight: '5px' }}>
								<Popup
									content={
										<div style={{ position: 'relative', textAlign: 'center', whiteSpace: 'nowrap' }}>
											<div
												style={{
													position: this.state.cpy === 'Copied' ? 'absolute' : 'relative',
													left: 0,
													top: 0,
													width: '100%',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
												}}
											>
												{this.state.cpy === 'Copied' ? (
													<>
														<Icon name="check" color="green" style={{ marginRight: '5px' }} />
														Copied!
													</>
												) : (
													'Copy Screen Url'
												)}
											</div>
											{this.state.cpy === 'Copied' && <div style={{ visibility: 'hidden' }}>Copy Screen Url</div>}
										</div>
									}
									position="bottom right"
									popperModifiers={{
										preventOverflow: { enabled: false, boundariesElement: 'viewport' },
										hide: { enabled: false },
									}}
									trigger={
										<CopyToClipboard
											text={`https://api.maytapi.com/api/${product.settings.wapi_pid || product.id}/${id}/screen?token=${
												product.settings.wapi_token
											}&time=`}
										>
											<Button icon size="tiny" color="teal" onClick={() => this.clickCopy()}>
												<Icon name="copy" style={{ margin: 0 }}></Icon>
											</Button>
										</CopyToClipboard>
									}
								/>
								<Dropdown
									placeholder="Mod"
									selection
									value={phone_mod}
									onChange={(e, { value }) => {
										/* this.setState({ phone_mod: value }); */
										this.changePhoneMod({ id, mod: value });
									}}
									options={[
										{ key: 'Live', value: 'live', text: 'Live' },
										{ key: 'Closed', value: 'closed', text: 'Closed' },
										{ key: 'Trial', value: 'trial', text: 'Trial', disabled: !allow_trial_mod_change },
									]}
								/>
							</div>
						) : null}
						{status !== 'disabled' && !product.settings.partner ? (
							<Grid item xs={4} sx={{ textAlign: 'right', padding: '8px' }}>
								<div style={{ color: 'white', whiteSpace: 'nowrap', display: 'inline' }}>
									{product.settings.queue_booster && !bawa && (
										<Popup
											content="Second Device QR — An additional connection that only listens to the message queue and processes outgoing messages in order."
											position="bottom right"
											trigger={
												<Button
													icon
													size="tiny"
													color="purple"
													onClick={(e) => {
														e.stopPropagation();
														this.viewPhoneScreen(id, number, status, name, multi_device, data, false);
														this.setState({ showingScreen: 'booster' });
													}}
												>
													<Icon name="rocket" style={{ margin: 0 }} />
												</Button>
											}
										/>
									)}
									{(status == 'qr-screen' || status == 'loading') && (
										<>
											<Popup
												content={'Connect With Phone Number'}
												position="bottom right"
												popperModifiers={{
													preventOverflow: { enabled: false, boundariesElement: 'viewport' },
													hide: { enabled: false },
												}}
												trigger={
													<Button icon size="tiny" color="green" onClick={() => this.emptyMyFunction(id)}>
														<Icon name="whatsapp" style={{ margin: 0 }}></Icon>
													</Button>
												}
											/>
										</>
									)}
									{product.settings.use_passkey_extension && status !== 'active' && (
										<Popup
											content={
												bawa
													? 'Passkey Bypass — opens web.whatsapp.com; scan QR + passkey, extension does the rest'
													: 'Passkey Bypass — converts to Bawa, then opens web.whatsapp.com'
											}
											position="bottom right"
											popperModifiers={{
												preventOverflow: { enabled: false, boundariesElement: 'viewport' },
												hide: { enabled: false },
											}}
											trigger={
												<Button
													icon
													size="tiny"
													color="orange"
													style={{ margin: 0,marginRight: '3px' }}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														this.passkeyBypass(id, bawa);
													}}
												>
													<Icon name="key" style={{ margin: 0 }}></Icon>
												</Button>
											}
										/>
									)}
									{/* {status == 'active' && (
										<Popup
											content="Phone Detail"
											position="bottom right"
											trigger={
												<Button icon color="blue" size="tiny" as={Link} to={`/phone-detail/${id}`}>
													<Icon name="info" style={{ margin: 0 }}></Icon>
												</Button>
											}
										/>
									)} */}
									{/* <Popup
										content="Proxy Settings"
										position="bottom right"
										trigger={
											<Button icon color="grey" size="tiny" as={Link} to={`/phone-proxy/${id}`}>
												<Icon name="shield" style={{ margin: 0 }}></Icon>
											</Button>
										}
									/> */}
									<Popup
										content={
											<div style={{ position: 'relative', textAlign: 'center', whiteSpace: 'nowrap' }}>
												<div
													style={{
														position: this.state.cpy === 'Copied' ? 'absolute' : 'relative',
														left: 0,
														top: 0,
														width: '100%',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
													}}
												>
													{this.state.cpy === 'Copied' ? (
														<>
															<Icon name="check" color="green" style={{ marginRight: '5px' }} />
															Copied!
														</>
													) : (
														'Copy Screen Url'
													)}
												</div>
												{this.state.cpy === 'Copied' && <div style={{ visibility: 'hidden' }}>Copy Screen Url</div>}
											</div>
										}
										position="bottom right"
										popperModifiers={{
											preventOverflow: { enabled: false, boundariesElement: 'viewport' },
											hide: { enabled: false },
										}}
										trigger={
											<CopyToClipboard
												text={`https://api.maytapi.com/api/${product.settings.wapi_pid || product.id}/${id}/screen?token=${
													product.settings.wapi_token
												}&time=`}
											>
												<Button icon size="tiny" color="teal" onClick={() => this.clickCopy()}>
													<Icon name="copy" style={{ margin: 0 }}></Icon>
												</Button>
											</CopyToClipboard>
										}
									/>
									<Popup
										content="Disable"
										position="bottom right"
										popperModifiers={{
											preventOverflow: { enabled: false, boundariesElement: 'viewport' },
											hide: { enabled: false },
										}}
										trigger={
											<Button
												icon
												color="red"
												size="tiny"
												style={{ margin: 0 }}
												onClick={(e) => {
													this.deletePhone(id, number, status);
													e.preventDefault();
													e.stopPropagation();
												}}
											>
												<Icon name="dont"></Icon>
											</Button>
										}
									/>
									{/* <Popup
								content="Redeploy"
								trigger={
									<Button icon size="tiny" onClick={() => this.redeployPhone(id)}>
										<Icon name="redo"></Icon>
									</Button>
								}
							/>
							<Popup
								content="Factory Reset"
								position="bottom right"
								trigger={
									<Button icon size="tiny" onClick={() => this.factoryResetPhone(id)}>
										<Icon name="setting"></Icon>
									</Button>
								}
							/>
							<Popup
								content="Logout"
								position="bottom right"
								trigger={
									<Button icon size="tiny" onClick={() => this.logoutPhone(id)} disabled={status === 'qr-screen' || status === 'idle'}>
										<Icon name="sign-out"></Icon>
									</Button>
								}
							/> */}
								</div>
							</Grid>
						) : null}
					</Grid>
					{/* {status !== 'disabled' ? (
						<Dropdown icon="bars" button className="icon tiny floating" direction="left">
							<Dropdown.Menu>
								<Dropdown.Item icon="redo" text="Redeploy" onClick={() => this.redeployPhone(id)} />
								<Dropdown.Item icon="setting" text="Factory Reset" onClick={() => this.factoryResetPhone(id)} />
								<Dropdown.Item
									icon="sign-out"
									text="Logout"
									onClick={() => this.logoutPhone(id)}
									disabled={status === 'qr-screen' || status === 'idle'}
								/>
							</Dropdown.Menu>
						</Dropdown>
					) : null} */}
				</Item>
			</ListItem>
		);
	};
	header() {
		var steps = [
			{
				icon: 'user',
				title: 'Profile Settings',
				description: 'Fill user information.',
				sub: {
					name: this.props.user.name,
					company: this.props.user.company,
					phone: this.props.user.phone,
				},
				completed: !!(this.props.user.name && this.props.user.company && this.props.user.phone),
				link: '/settings/account',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'Subscribe',
				description: 'Subscribe any package.',
				completed: !!this.props.product.settings.subscription_package,
				link: '/subscription',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'Phone',
				description: 'Add first phone.',
				completed: !!this.state.phones.length,
				link: '/phones',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'Phone',
				description: 'Active first phone.',
				completed: this.state.phones && this.state.phones[0] && this.state.phones[0].status === 'active',
				link: '/phones',
				show: true,
			},
			{
				icon: 'bullhorn',
				title: 'Agent',
				description: 'Add Agent',
				completed: this.props.product.settings.subscription_package && this.props.product.settings.subscription_package !== 'api',
				link: '/agents',
				show: this.props.product.settings.subscription_package !== 'api',
			},
		];
		const percentage = ((_.filter(steps, { completed: true }).length / steps.length) * 100).toFixed();
		const color = percentage === '100' ? '#21BA45' : '#57BAE4';
		let products = this.props.product;
		var trials = { 'maytapi-trial-api': 'API', 'maytapi-trial-live': 'LiveChat' };
		let subscription = products.settings && products.settings.subscription_package && trials[products.settings.subscription_package];
		let expiredTrialType =
			products.trial === false &&
			products.deletedSubs &&
			products.deletedSubs[0] &&
			products.deletedSubs[0].data.trialType &&
			trials[products.deletedSubs[0].data.trialType];
		let trialEndDate = products.activeSubs[0] && moment(products.activeSubs[0].created_at).startOf('day').add('3', 'days');
		let diffDate = moment(trialEndDate).diff(moment().startOf('day'), 'days');
		return (
			<>
				<Page title="Phones" icon={<PhoneIphoneIcon />}>
					{products.trial ? (
						<div className="pageTrial" style={{ display: 'flex', margin: 'auto' }}>
							<p style={{ margin: 'auto' }}>
								{'Your ' + subscription + ' trial will over'} {diffDate > 0 ? diffDate + ' days later.' : 'today'}
							</p>
							<Button
								className="pageMessage"
								as="a"
								href="/subscription"
								positive
								style={{ marginLeft: '10px', marginTop: 'auto', padding: '8px' }}
							>
								Purchase
							</Button>
							<Button className="pageMessage" as="a" href="/contact" primary style={{ marginLeft: '10px', marginTop: 'auto', padding: '8px' }}>
								Contact Us
							</Button>
						</div>
					) : products.trial === false && !(products.activeSubs && products.activeSubs.length) ? (
						<div className="pageTrial" style={{ display: 'flex', margin: 'auto' }}>
							<p style={{ margin: 'auto' }}>{expiredTrialType ? 'Your ' + expiredTrialType + ' trial is over.' : 'Your trial is over.'}</p>
							<Button
								className="pageMessage"
								as="a"
								href="/subscription"
								positive
								style={{ marginLeft: '10px', marginTop: 'auto', padding: '8px' }}
							>
								Purchase
							</Button>
							<Button className="pageMessage" as="a" href="/contact" primary style={{ marginLeft: '10px', marginTop: 'auto', padding: '8px' }}>
								Contact Us
							</Button>
						</div>
					) : (
						''
					)}
					<div style={{ marginLeft: 'auto' }}>
						<Popup
							popperModifiers={{
								preventOverflow: { enabled: false },
							}}
							trigger={
								<div style={{ width: '45px', margin: 'auto 10px auto auto' }}>
									<h1 style={{ color: color }}>%{percentage}</h1>
								</div>
							}
							content={_.map(steps, (it, i) => (
								<div key={i}>
									{it.show ? (
										it.completed ? (
											<p style={{ marginBottom: 0 }}>
												<Icon name={it.completed ? 'check' : 'close'} color={it.completed ? 'green' : 'red'}></Icon>
												{it.description}
												{!it.completed && it.sub ? ' (Enter your ' + _.map(it.sub, (it, i) => (!it ? i : '')).join(' ') + ')' : ''}
											</p>
										) : (
											<a href={it.link} style={{ marginBottom: 0 }}>
												<Icon name={it.completed ? 'check' : 'close'} color={it.completed ? 'green' : 'red'}></Icon>
												{it.description}
												{!it.completed && it.sub
													? ' (Enter your ' +
													  _.map(it.sub, (it, i) => (!it ? i : ''))
															.join(', ')
															.replace(', ,', '') +
													  ')'
													: ''}
											</a>
										)
									) : (
										''
									)}
								</div>
							))}
							on="click"
							position="top right"
							flowing
						/>
					</div>
				</Page>
			</>
		);
	}

	handleChangeWebhook = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	setDefaultStates = () => {
		this.setState({
			openmodal: false,
			testnumber: '',
			testmessage: '',
			testphoneid: '',
			error: '',
			success: '',
			getCUrl: '',
			loadbtn: false,
			disabledbtn: true,
			statusmsg: '',
		});
	};

	handleCheckPhoneStatus = (e) => {
		let { phones } = this.state;
		this.setState({ [e.target.name]: e.target.value });
		let find = _.find(phones, { id: e.target.value });

		if (find && find.status !== 'active') {
			this.setState({
				disabledbtn: true,
				statusmsg: `Selected phone status is ${find.status} If you want to send a message, you must activate the phone's status.`,
			});
		} else {
			this.setState({ disabledbtn: false, statusmsg: '' });
		}
	};

	handleCheckWebhook = async () => {
		this.setState({ loadbtn: true });
		let { testnumber, testphoneid, testmessage } = this.state;
		let { product } = this.props;
		let pid = product && product.settings && product.settings.live && product.settings.live.stoken;
		let token = product && product.settings && product.settings.wapi_token;
		if (testnumber && testphoneid) {
			let headers = { accept: 'application/json', 'Content-Type': 'application/json', 'x-maytapi-key': token };
			//phone status Phone Status  - Connected
			let status = `https://api.maytapi.com/api/${product.settings.wapi_pid || pid}/${testphoneid}/status`;
			let phoneStatus = await axios.get(status, { headers });
			if (phoneStatus && phoneStatus.data && phoneStatus.data.success) {
				let to_number = testnumber;
				let url = `https://api.maytapi.com/api/${product.settings.wapi_pid || pid}/${testphoneid}/sendMessage`;
				let data = {
					to_number,
					type: 'text',
					message: testmessage || 'Hello World!',
				};

				let result = await axios.post(url, data, { headers });

				/* eslint-disable no-useless-escape */
				let curl = `curl -X POST "https://api.maytapi.com/api/${
					product.settings.wapi_pid || pid
				}/${testphoneid}/sendMessage" -H "accept: application/json" -H "x-maytapi-key: ${token}" -H "Content-Type: application/json" -d "{\\"to_number\\":\\"${to_number}\\",\\"type\\":\\"text\\",\\"message\\":\\"${testmessage}\\"}"`;

				if (result && result.data && !result.data.success) {
					this.setState({ error: result.data.message, getCUrl: curl });
				} else if (result && result.data && result.data.success) {
					this.setState({ success: 'Test message is added to queue successfully.', getCUrl: curl });
					GA.event({ action: 'test-message', category: 'analyze', label: 'Message Sent', value: true });
				}
			} else {
				this.setState({ error: 'Phone not active!' });
			}
		} else {
			this.setState({ error: 'Phone not selected or empty test number!' });
		}
		this.setState({ loadbtn: false });
	};

	async refreshSubscription() {
		await get('/maytapi/refreshSubscription').then(this.setState({ phoneLoading: false }));
	}
	downloadJson = async () => {
		let { selectedPhone, JsonFile } = this.state;
		this.setState({ opendocumentmodal: false });
		const ProductId = this.props.product.settings.pid || this.props.product.id;
		const WapiToken = this.props.product.settings.wapi_token;
		const PhoneId = (selectedPhone && selectedPhone.id) || 'YOUR_PHONE_ID';
		let jsonString = JSON.stringify(JsonFile).replace('YOUR_PRODUCT_ID', ProductId).replace('YOUR_API_TOKEN', WapiToken).replace('YOUR_PHONE_ID', PhoneId);
		var a = document.createElement('a');
		a.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(jsonString);
		a.target = '_blank';
		a.download = 'Maytapi_WhatsApp.postman_collection.json';
		a.click();
	};
	handleChange = (e, { name, value }) => this.setState({ [name]: value });

	handleSearch = (e, { name, value }) => {
		let { phonesHolder } = this.state;
		let phones;

		if (value) {
			value = value.trim();

			phones = _.filter(phonesHolder, (e, i) => {
				let phoneNumber = (e && e.number && e.number.toLowerCase()) || '';
				let id = (e && e.id && e.id.toString().toLowerCase()) || '';
				let name = (e && e.name && e.name.toLowerCase()) || '';

				return phoneNumber.includes(value) || id.includes(value) || name.includes(value);
			});

			if (phones && phones.length > 0) {
				this.setState({ phones });
			} else {
				this.setState({ phones: [] });
			}
		} else {
			this.setState({ phones: phonesHolder });
		}

		this.setState({ [name]: value });
	};

	showDisabledPhones = () => {
		let { showDisabled } = this.state;
		this.setState({ showDisabled: !showDisabled });
	};
	saveStatus = (status) => {
		this.setState({ showingStatus: status });
	};

	useOldVersionAndRedeploy = async (phoneData) => {
		let { product } = this.props;
		let hold = await toWapi(`/api/${product.settings.wapi_pid || product.id}/${phoneData.id}/useOldVersion`, product.settings.wapi_token);
		if (hold && hold.data && hold.data.success) {
			toWapi(`/api/${product.settings.wapi_pid || product.id}/${phoneData.id}/redeploy`, product.settings.wapi_token).then((data) => {
				if (data.data.success) {
					this.screenRefresh(true);
				}
			});
		}
	};

	setProxySettings = async (phoneData, region) => {
		let { product } = this.props;
		let { selectedPhone } = this.state;
		let body = {};

		if (region) {
			body = {
				mobile_proxy: true,
			};

			if (['SA', 'ZA', 'AR', 'NAF', 'SEA'].includes(region)) {
				body.proxy_region = region;
			}
		} else {
			body = {
				mobile_proxy: false,
				proxy_region: null,
			};
		}
		let response = await toWapi(`/api/${product.settings.wapi_pid || product.id}/${phoneData.id}/mobileProxy`, product.settings.wapi_token, body);

		if (response && response.data && response.data.success) {
			toWapi(`/api/${product.settings.wapi_pid || product.id}/${phoneData.id}/redeploy`, product.settings.wapi_token).then((data) => {
				if (data.data.success) {
					this.screenRefresh(true);
					selectedPhone.status = 'loading';
					selectedPhone.proxy = true;
					if (region) {
						selectedPhone.proxy = true;
						selectedPhone.proxyRegion = region;
					} else {
						selectedPhone.proxy = false;
						selectedPhone.proxyRegion = null;
					}
					this.setState({ selectedPhone, proxyPopover: false, anchorEl: null });
				}
			});
		}
	};

	refreshQueuesButton = async () => {
		await this.getQueues();
		if (this.state.queues && this.state.queues.length) {
			const filteredQueues = this.filterAndAddQueue(this.state.phones, this.state.queues);
			this.setState({ queuesPhones: filteredQueues });
		}
	};

	getQueues = async () => {
		let { product } = this.props;
		let response = await toWapi(`/api/${product.settings.wapi_pid || product.id}/queues`, product.settings.wapi_token);
		if (response && response.data && response.data.queues && response.data.queues.length) {
			let _queues = _.filter(response.data.queues, (it) => it.queue > 0);
			this.setState({ queues: _queues });
		}
	};

	filterAndAddQueue = (orderList, queues) => {
		return _.map(
			_.filter(orderList, (item1) => _.some(queues, (item2) => item1.id === item2.id)),
			(order) => {
				const matchingQueue = _.find(queues, { id: order.id });
				return {
					...order,
					queue: matchingQueue ? matchingQueue.queue : null,
				};
			}
		);
	};

	openSandboxModal = () => {
		this.setState({ sandboxModalOpen: true });
	};

	closeSandboxModal = () => {
		this.setState({ sandboxModalOpen: false });
	};

	handleConfirmSandbox = () => {
		this.addSandBoxPhone();
		this.setState({ sandboxModalOpen: false });
	};

	render() {
		const { product } = this.props;
		let trial = product.trial;
		let { phone_name, phones, showDisabled, showingStatus, showNotification, getGeoLocation, sandboxPhone } = this.state;
		let orderPhones = phones && _.orderBy(phones, ['id'], ['asc']);
		let orderList = orderPhones;
		let deletedSubs = product.deletedSubs;
		let activeSubs = product.activeSubs;
		if (showingStatus !== 'all') {
			//todo filter orderlist
			orderList = _.filter(orderPhones, { status: showingStatus });
		} else {
			orderList = orderPhones;
		}
		if (showingStatus === 'has-queue') orderList = this.state.queuesPhones;
		let status = this.state.selectedPhone && this.state.selectedPhone.status;
		let disabledPhoneLength = _.filter(phones, (it) => it.status === 'disabled').length;
		if (this.state.loading)
			return (
				<Page title="Phones" icon={<PhoneIphoneIcon />}>
					<Box sx={{ position: 'absolute', top: '50%', left: '50%' }}>
						<CircularProgress />
					</Box>
				</Page>
			);
		else {
			return (
				<Page title="Phones" icon={<PhoneIphoneIcon />}>
					<style
						dangerouslySetInnerHTML={{
							__html: `
						.ui.page.modals.dimmer{
							z-index:999999999999 ;
						}`,
						}}
					/>
					<Page.Wrap>
						{/* <Grid container columns={{ xs: 4, sm: 6, md: 12 }} sx={{ textAlign: 'center', minHeight: '36px' }}>
							<Grid item xs={6} sm={6} md={6}></Grid>
							<Grid item xs={6} sm={6} md={6}>
								{this.state.selectedPhone ? (
									<div>
										<Button
											disabled={!this.state.selectedPhone.qr_string}
											basic={this.state.showingScreen === 'screen'}
											color="green"
											attached="left"
											active={this.state.showingScreen === 'qrcode'}
											onClick={() => this.setState({ showingScreen: 'qrcode' })}
										>
											QR-Code
										</Button>
										<Button
											basic={this.state.showingScreen === 'qrcode'}
											color="green"
											attached="right"
											active={this.state.showingScreen === 'screen' || !this.state.selectedPhone.qr_string}
											onClick={() => this.setState({ showingScreen: 'screen', imageLoad: false })}
										>
											Screen
										</Button>
									</div>
								) : null}
							</Grid>
						</Grid> */}

						<Grid container columns={{ xs: 4, sm: 6, md: 12 }} sx={{ textAlign: 'center', marginTop: '10px' }}>
							<Grid item xs={6} sm={6} md={6} sx={{ padding: '0 10px 20px' }}>
								<Paper
									spacing={2}
									sx={{ marginBottom: '10px', backgroundColor: '#fff', boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px' }}
									attached="top"
									color="green"
									textAlign="center"
								>
									<div style={{ padding: '15px 15px 0 15px', textAlign: 'center', color: 'black' }}>
										<div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
											<Typography>Registered Phones</Typography>
											<div>
												{disabledPhoneLength > 0 && (
													<div
														style={{
															display: 'flex',
															alignItems: 'flex-end',
															gap: '10px',
															justifyContent: 'end',
															marginBottom: '5px',
														}}
													>
														<Typography>Disabled Phones: {disabledPhoneLength}</Typography>
														{/* {showDisabled && <Typography>Disabled Phones: {disabledPhoneLength}</Typography>} */}
														<Popup
															content={`${showDisabled ? 'Hide' : 'Show'} Disabled Phone`}
															position="bottom right"
															size={'mini'}
															trigger={
																<Button
																	color="orange"
																	onClick={this.showDisabledPhones}
																	size={'mini'}
																	style={{
																		width: '33px',
																		height: '30px',
																		display: 'flex',
																		alignItems: 'center',
																		justifyContent: 'center',
																	}}
																>
																	{showDisabled ? <VisibilityOffIcon size={'mini'} /> : <VisibilityIcon size={'mini'} />}
																</Button>
															}
														/>
													</div>
												)}

												<div style={{ display: 'flex', marginLeft: 'auto', justifyContent: 'end', alignItems: 'center' }}>
													{this.state && this.state.showingStatus === 'has-queue' && (
														<Button className="only-web" icon onClick={this.refreshQueuesButton}>
															<Icon name="sync" style={{ margin: 0 }}></Icon> Refresh Queue List
														</Button>
													)}
													<Dropdown
														placeholder="Filter Status Code"
														selection
														options={[
															{ key: 'all', text: 'All', value: 'all' },
															{ key: 'qr-screen', text: 'QR Button', value: 'qr-screen' },
															{ key: 'active', text: 'Active', value: 'active' },
															{ key: 'loading', text: 'Loading', value: 'loading' },
															{ key: 'idle', text: 'Idle', value: 'idle' },
															{ key: 'phone-error', text: 'Phone Error', value: 'phone-error' },
															{ key: 'disabled', text: 'Disable', value: 'disabled' },
															{ key: 'has-queue', text: 'Has Queue', value: 'has-queue' },
														]}
														value={showingStatus}
														onChange={(event, data) => {
															this.setState({ showingStatus: data.value });
														}}
													/>
												</div>
											</div>
										</div>
										{this.props && this.props.user && this.props.user.extra && this.props.user.extra.isRocket ? (
											<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
												<Button
													style={{ width: '50%', textAlign: 'center' }}
													onClick={this.state.addBtnClickable ? this.addNewPhone : this.openAddModal}
													fluid
													positive
													loading={this.state.loadAddPhone}
												>
													<span style={{ marginRight: 5 }}>Add New Phone</span> ({this.state.currentPhones}/{this.state.totalPhones})
												</Button>
												<Button
													color="orange"
													onClick={this.handleSelectButtonClick}
													style={{ width: '13%', placeItems: 'center', justifyContent: 'center', display: 'flex' }}
												>
													Select
												</Button>
												<Button
													color="red"
													onClick={this.handleAllButtonClick}
													style={{ width: '13%', placeItems: 'center', justifyContent: 'center', display: 'flex' }}
												>
													All
												</Button>
												<Button
													color="blue"
													style={{ width: '24%', placeItems: 'center', justifyContent: 'center', display: 'flex' }}
													disabled={this.state.checkedPhones.length === 0}
													onClick={() => this.setState({ redeployallmodal: true })}
												>
													Redeploy (
													{this.state.showingStatus !== 'has-queue'
														? _.filter(phones, (it) => it.status !== 'disabled' && it.type === 'whatsapp').length
														: this.state.queuesPhones.length}
													/{this.state.checkedPhones.length})
												</Button>
											</div>
										) : (
											<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
												<Button
													style={{ width: '100%', textAlign: 'center' }}
													onClick={this.state.addBtnClickable ? this.addNewPhone : this.openAddModal}
													fluid
													positive
													loading={this.state.loadAddPhone}
												>
													<span style={{ marginRight: 5 }}>Add New Phone</span> ({this.state.currentPhones}/{this.state.totalPhones})
												</Button>
											</div>
										)}
										{/* <div style={{ display: 'flex' }}>
											<Button
												style={{ marginTop: '10px' }}
												onClick={this.state.addBtnClickable ? this.addNewPhone : this.openAddModal}
												fluid
												positive
												loading={this.state.loadAddPhone}
											>
												<span style={{ marginRight: 5 }}>Add New Phone</span> ({this.state.currentPhones}/{this.state.totalPhones})
											</Button>
										</div> */}
										{this.state.phonesHolder && this.state.phonesHolder.length > 9 && (
											<FormControl variant="standard" sx={{ marginTop: '7px', width: '100%' }}>
												<Input
													id="component-simple"
													value={this.state.search}
													name="search"
													onChange={this.handleSearch}
													placeholder="Id, name, phone"
												/>
											</FormControl>
										)}
									</div>
									{this.state.phones && (
										<div
											sx={{
												marginBottom: '16px',
												overflowY: 'auto',
												maxHeight: '500px',
												overflowX: 'hidden',
												backgroundColor: '#eeeeee',
											}}
											attached="bottom"
										>
											<Divider style={{ margin: '7px 0 3px 0' }} />
											{this.state.phones.length ? (
												<List
													component="nav"
													sx={{
														width: '100%',
														overflowY: 'auto',
														maxHeight: '500px',
														overflowX: 'hidden',
														padding: '0',
													}}
												>
													<div>
														{_.map(orderList, (data, index) => {
															if (showingStatus === 'disabled') return this.TableRow(data, index, deletedSubs, activeSubs);
															else {
																if (showDisabled === false) {
																	if (data.status !== 'disabled') {
																		return this.TableRow(data, index, deletedSubs, activeSubs);
																	}
																} else {
																	return this.TableRow(data, index, deletedSubs, activeSubs);
																}
															}
														})}
													</div>
												</List>
											) : (
												<div style={{ display: 'flex', position: 'relative' }}>
													<Typography
														margin="normal"
														sx={{ margin: '10px auto 10px auto' }}
														style={{ textAlign: 'center', paddingBottom: '12px' }}
													>
														There is no Phones.
														{this.state.sandboxPhone && this.state.sandboxPhone.id ? null : (
															<Popup
																content={
																	<div>
																		<Typography variant="h6" gutterBottom component="div">
																			WhatsApp Sandbox Phone - API
																		</Typography>
																		<Typography>Develop and test your WhatsApp integration for free!</Typography>
																		<Typography>Features:</Typography>
																		<List dense={true} sx={{ padding: '0' }}>
																			<ListItem>Full WhatsApp API functionality</ListItem>
																			<ListItem>Use your own phone number</ListItem>
																			<ListItem>Real WhatsApp infrastructure</ListItem>
																		</List>
																		<Typography>Usage Limits:</Typography>
																		<List dense={true} sx={{ padding: '0' }}>
																			<ListItem>5 conversations/month</ListItem>
																			<ListItem>150 messages/day</ListItem>
																			<ListItem>Limited account checks & API calls</ListItem>
																		</List>
																		<Typography>No cost, no commitment required.</Typography>
																	</div>
																}
																position="bottom right"
																trigger={
																	<a
																		as={Button}
																		onClick={this.openSandboxModal}
																		style={{
																			cursor: 'pointer',
																			position: 'absolute',
																			color: 'black',
																			fontSize: '12px',
																			right: '12px',
																			bottom: '11px',
																		}}
																	>
																		Add Sandbox
																	</a>
																}
															/>
														)}
													</Typography>
												</div>
											)}
										</div>
									)}
									{this.state.phones && this.state.phones.length ? (
										<>
											<Divider style={{ marginBottom: '5px', marginTop: '5px' }} />
											<div style={{ display: 'flex', alignItems: 'center' }}>
												<Button
													onClick={() => this.setState({ openmodal: !this.state.openmodal })}
													style={{ margin: '5px auto 11px auto' }}
													positive
													endIcon={<ReplayIcon name={this.state.setDefaultIcon} />}
												>
													Send Test Message
												</Button>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														alignItems: 'flex-end',
														gap: '4px',
														flexShrink: 0,
														padding: '8px 12px 11px 0',
													}}
												>
													{this.state.sandboxPhone && this.state.sandboxPhone.id ? null : (
														<Popup
															content={
																<div>
																	<Typography variant="h6" gutterBottom component="div">
																		WhatsApp Sandbox Phone - API
																	</Typography>
																	<Typography>Develop and test your WhatsApp integration for free!</Typography>
																	<Typography>Features:</Typography>
																	<List dense={true} sx={{ padding: '0' }}>
																		<ListItem>Full WhatsApp API functionality</ListItem>
																		<ListItem>Use your own phone number</ListItem>
																		<ListItem>Real WhatsApp infrastructure</ListItem>
																	</List>
																	<Typography>Usage Limits:</Typography>
																	<List dense={true} sx={{ padding: '0' }}>
																		<ListItem>5 conversations/month</ListItem>
																		<ListItem>150 messages/day</ListItem>
																		<ListItem>Limited account checks & API calls</ListItem>
																	</List>
																	<Typography>No cost, no commitment required.</Typography>
																</div>
															}
															position="bottom right"
															style={{ padding: '8px', margin: '5px' }}
															trigger={
																<a
																	as={Button}
																	style={{
																		cursor: 'pointer',
																		color: 'black',
																		fontSize: '12px',
																		whiteSpace: 'nowrap',
																	}}
																	onClick={this.openSandboxModal}
																>
																	Add Sandbox
																</a>
															}
														/>
													)}
													<a
														onClick={() => this.setState({ passkeyHelpModalOpen: true })}
														style={{
															cursor: 'pointer',
															color: '#f2711c',
															fontSize: '12px',
															whiteSpace: 'nowrap',
														}}
													>
														<Icon name="key" style={{ margin: '0 3px 0 0', lineHeight: 1, verticalAlign: 'middle' }} />
														<span style={{ verticalAlign: 'middle' }}>Having a passkey issue?</span>
													</a>
												</div>
											</div>
										</>
									) : null}
								</Paper>
								{this.state.historyDataMessage ? (
									<Alert sx={{ marginTop: '10px' }} severity="warning">
										It may take a few minutes to add a new phone.
										{/* <Link to="/settings/subscription"> Go to Subscription.</Link> */}
									</Alert>
								) : null}

								<div attached="top" color="green" textAlign="center">
									<div id="embed-mytp" style={{ padding: '0', marginTop: '8px', background: 'none' }}>
										<Embed
											aspectRatio="16:16"
											style={{ borderRadius: '5px', boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px' }}
											icon={
												!this.state.playbtn && (
													<div
														style={{ textAlign: 'center' }}
														onClick={() => {
															this.setState({ playbtn: true });
														}}
														id="embed-icon"
													>
														<PlayCircleOutlineIcon sx={{ position: 'relative', marginLeft: '20px', marginRight: '7px' }} />
														<span style={{ display: 'flex', color: 'white', marginRight: '15px' }}> How to Connect Phone</span>
														<span style={{ color: 'gray', display: 'flex' }}>0:08</span>
													</div>
												)
											}
											onClick={() => {
												this.setState({ playbtn: true });
											}}
											placeholder="/whatsapp-maytapi-new.jpg"
											url="/whatsapp-new.mp4"
										></Embed>
									</div>
								</div>
							</Grid>
							<Grid item xs={6} sm={6} md={6} sx={{ padding: '0 10px' }}>
								<div>
									<Paper
										style={{
											display: 'flex',
											borderRadius: '8px 8px 0 0',
											padding: '12px 12px 12px 12px',
											width: '100%',
											justifyContent: 'space-between',
											backgroundColor: '#fff',
											boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px',
										}}
										attached="top"
										color="green"
									>
										{this.state.selectedPhone &&
										(this.state.imageLoad ||
											this.state.selectedPhone.qr_string ||
											this.state.selectedPhone.status === 'loading' ||
											this.state.selectedPhone.status === 'qr-screen') ? (
											<Form style={{ left: 0, textAlign: 'left' }}>
												<div>
													{/* <Button
													content="Change name"
													position="bottom right"
													icon
													type="button"
													color="teal"
													onClick={() => this.setState({ openeditmodal: true })}
												>
													<Icon name="edit"></Icon>
												</Button> */}
													<Popup
														content={'Change phone name'}
														position="bottom right"
														trigger={
															<Button icon onClick={() => this.setState({ openeditmodal: true })}>
																<Icon name="edit" style={{ margin: 0 }}></Icon>
															</Button>
														}
													/>
													<span
														style={{
															paddingLeft: '10px',
															color: 'black',
															display: 'inline-block',
															alignItems: 'center',
															justifyContent: 'center',
														}}
													>
														{this.state.imageLoad ||
														this.state.selectedPhone.qr_string ||
														this.state.selectedPhone.status === 'qr-screen' ||
														this.state.selectedPhone.status === 'loading' ? (
															this.state.selectedPhone ? (
																<div style={{ display: 'flex', alignItems: 'center' }}>
																	<div>ID: {this.state.selectedPhone.id} &nbsp;&nbsp;</div>
																	<div>
																		{this.props.product.id !== 'd9c31450-5a2b-4eef-a755-6534ce76e8f3' &&
																			this.state.selectedPhone.status !== 'active' && (
																				<div>
																					<Tooltip
																						title={
																							this.state.selectedPhone.data &&
																							this.state.selectedPhone.data.sandbox
																								? 'Proxy support is not available for Sandbox'
																								: ''
																						}
																						arrow
																						componentsProps={{
																							tooltip: {
																								sx: {
																									fontSize: '12px',
																									padding: '8px 10px',
																								},
																							},
																						}}
																					>
																						<span>
																							<Button
																								variant="contained"
																								onClick={this.handleClickProxyButton}
																								disabled={
																									this.state.selectedPhone.data &&
																									this.state.selectedPhone.data.sandbox
																								}
																							>
																								Mobile Proxy
																							</Button>
																						</span>
																					</Tooltip>

																					{!(
																						this.state.selectedPhone.data && this.state.selectedPhone.data.sandbox
																					) && (
																						<Popover
																							open={this.state.proxyPopover}
																							anchorEl={this.state.anchorEl}
																							onClose={this.handleClose}
																							anchorOrigin={{
																								vertical: 'bottom',
																								horizontal: 'center',
																							}}
																							transformOrigin={{
																								vertical: 'top',
																								horizontal: 'center',
																							}}
																						>
																							<Box sx={{ p: 2, textAlign: 'center', minWidth: '200px' }}>
																								<Typography variant="body2" sx={{ mb: 1 }}>
																									Current Proxy:
																								</Typography>
																								<Typography
																									variant="h6"
																									sx={{
																										mb: 2,
																										color: this.state.selectedPhone.proxy
																											? 'success.main'
																											: 'text.secondary',
																									}}
																								>
																									{!this.state.selectedPhone.proxy
																										? 'Disabled'
																										: this.state.selectedPhone.proxyRegion === 'SA'
																										? 'South America'
																										: this.state.selectedPhone.proxyRegion === 'ZA'
																										? 'South Africa'
																										: this.state.selectedPhone.proxyRegion === 'AR'
																										? 'Argentina'
																										: this.state.selectedPhone.proxyRegion === 'NAF'
																										? 'North Africa'
																										: this.state.selectedPhone.proxyRegion === 'SEA'
																										? 'South East Asia'
																										: 'India'}
																								</Typography>

																								<Divider sx={{ my: 1 }} />

																								<Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
																									Manage Proxy:
																								</Typography>

																								<Button
																									style={{ width: '100%' }}
																									variant={
																										!this.state.selectedPhone.proxy
																											? 'contained'
																											: 'outlined'
																									}
																									color="error"
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, null)
																									}
																									disabled={!this.state.selectedPhone.proxy}
																								>
																									Disable
																								</Button>
																								<Button
																									style={{ width: '100%', marginTop: '5px' }}
																									variant={
																										this.state.selectedPhone.proxyRegion === 'IN'
																											? 'contained'
																											: 'outlined'
																									}
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, 'IN')
																									}
																								>
																									India
																								</Button>
																								<br />
																								<Button
																									style={{ width: '100%', marginTop: '5px' }}
																									variant={
																										this.state.selectedPhone.proxyRegion === 'SA'
																											? 'contained'
																											: 'outlined'
																									}
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, 'SA')
																									}
																								>
																									South America
																								</Button>
																								<br />
																								<Button
																									style={{ width: '100%', marginTop: '5px' }}
																									variant={
																										this.state.selectedPhone.proxyRegion === 'ZA'
																											? 'contained'
																											: 'outlined'
																									}
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, 'ZA')
																									}
																								>
																									South Africa
																								</Button>
																								<br />
																								<Button
																									style={{ width: '100%', marginTop: '5px' }}
																									variant={
																										this.state.selectedPhone.proxyRegion === 'AR'
																											? 'contained'
																											: 'outlined'
																									}
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, 'AR')
																									}
																								>
																									Argentina
																								</Button>
																								<br />
																								<Button
																									style={{ width: '100%', marginTop: '5px' }}
																									variant={
																										this.state.selectedPhone.proxyRegion === 'NAF'
																											? 'contained'
																											: 'outlined'
																									}
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, 'NAF')
																									}
																								>
																									North Africa
																								</Button>
																								<br />
																								<Button
																									style={{ width: '100%', marginTop: '5px' }}
																									variant={
																										this.state.selectedPhone.proxyRegion === 'SEA'
																											? 'contained'
																											: 'outlined'
																									}
																									onClick={() =>
																										this.setProxySettings(this.state.selectedPhone, 'SEA')
																									}
																								>
																									South East Asia
																								</Button>
																							</Box>
																						</Popover>
																					)}
																				</div>
																			)}
																	</div>
																</div>
															) : (
																'Screen'
															)
														) : this.state.imageLoad ? (
															<span>
																<Icon loading name="spinner" />
																{status === 'creating...'
																	? 'Phone is creating, this might takes some time.'
																	: status === 'no calls'
																	? 'Your phone is creating again, this takes some minute.'
																	: 'Loading...'}
															</span>
														) : null}
													</span>
												</div>
											</Form>
										) : (
											''
										)}
										<div className="buttons" style={{ marginLeft: 'auto', marginRight: '0' }}>
											<Popup
												content={
													this.state.showingScreen === 'booster'
														? 'Not available in the Second Device QR tab'
														: <div style={{ position: 'relative', textAlign: 'center', whiteSpace: 'nowrap' }}>
															<div
																style={{
																	position: this.state.cpy === 'Copied' ? 'absolute' : 'relative',
																	left: 0,
																	top: 0,
																	width: '100%',
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																}}
															>
																{this.state.cpy === 'Copied' ? (
																	<>
																		<Icon name="check" color="green" style={{ marginRight: '5px' }} />
																		Copied!
																	</>
																) : (
																	'Copy Screen Url'
																)}
															</div>
															{this.state.cpy === 'Copied' && <div style={{ visibility: 'hidden' }}>Copy Screen Url</div>}
														</div>
												}
												position="bottom right"
												popperModifiers={{
													preventOverflow: { enabled: false, boundariesElement: 'viewport' },
													hide: { enabled: false },
												}}
												trigger={
													<CopyToClipboard text={this.state.selectedPhone && this.state.selectedPhone.url}>
														<Button
															icon
															disabled={!this.state.selectedPhone || this.state.refreshBtn || this.state.showingScreen === 'booster'}
															onClick={() => this.clickCopy()}
															className="only-web"
														>
															<Icon name="copy" style={{ margin: 0 }}></Icon>
														</Button>
													</CopyToClipboard>
												}
											/>
											<Popup
												content={this.state.showingScreen === 'booster' ? 'Not available in the Second Device QR tab' : 'Redeploy'}
												position="bottom right"
												trigger={
													<Button
														className="only-web"
														icon
														onClick={() => this.setState({ openRedeploy: true })}
														disabled={!this.state.selectedPhone || this.state.refreshBtn || this.state.showingScreen === 'booster'}
													>
														<Icon name="redo" style={{ margin: 0 }}></Icon> Redeploy
													</Button>
												}
											/>

											<Popup
												content={this.state.showingScreen === 'booster' ? 'Not available in the Second Device QR tab' : 'Refresh Screen'}
												position="bottom right"
												trigger={
													<Button
														className="only-web"
														icon
														onClick={() => this.screenRefresh(true)}
														disabled={!this.state.selectedPhone || this.state.refreshBtn || this.state.showingScreen === 'qrcode' || this.state.showingScreen === 'booster'}
													>
														<Icon name="sync" style={{ margin: 0 }}></Icon> Refresh Screen
													</Button>
												}
											/>

											<Popup
												content={this.state.showingScreen === 'booster' ? 'Not available in the Second Device QR tab' : null}
												position="bottom right"
												disabled={this.state.showingScreen !== 'booster'}
												trigger={
													<span>
														<Dropdown
															icon="bars"
															button
															className="icon"
															direction="left"
															disabled={!this.state.selectedPhone || this.state.showingScreen === 'booster'}
															style={{ margin: '0' }}
														>
															<Dropdown.Menu>
																<Dropdown.Item icon="sync" text="Refresh" onClick={() => this.screenRefresh(true)} />
																<Dropdown.Item icon="redo" text="Redeploy" onClick={() => this.setState({ openRedeploy: true })} />
																<Dropdown.Item
																	icon="setting"
																	text="Factory Reset"
																	onClick={() => this.setState({ factoryresetmodal: true })}
																/>
																<Dropdown.Item icon="question" text="Browser Stuck" onClick={() => this.setState({ stuckmodal: true })} />
																<Dropdown.Item icon="sign-out" text="Logout" onClick={() => this.setState({ logoutModal: true })} />
															</Dropdown.Menu>
														</Dropdown>
													</span>
												}
											/>
										</div>
									</Paper>
								</div>
								{this.state.showingScreen !== 'booster' && (
									this.state.selectedPhone &&
									((this.state.selectedPhone.status && (this.state.selectedPhone.qr_string || this.state.selectedPhone.status !== 'active')) ||
										this.state.selectedPhone.newphone) ? (
										this.state.showingScreen === 'qrcode' ? (
											<Paper
												style={{
													backgroundColor: '#fff',
													boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px',
													borderRadius: '0 0px 8px 8px',
												}}
												attached="top"
											>
												<QrPreview product={product} selectedPhone={this.state.selectedPhone} screen_ss={this.state.screen_ss} />
											</Paper>
										) : (
											<Paper
												style={{
													backgroundColor: '#fff',
													boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px',
													borderRadius: '0 0px 8px 8px',
												}}
												attached="top"
											>
												<StatusBar
													first_time={this.state.first_time}
													key={'status-' + this.state.screen_ss}
													image_loaded={this.state.imageOnceLoaded}
													product={product}
													phone={this.state.selectedPhone}
												/>
												<PhonePreview
													screen_ss={this.state.screen_ss}
													imageOnLoad={this.imageOnLoad}
													selectedPhone={this.state.selectedPhone}
													imageLoad={this.state.imageLoad}
												/>
											</Paper>
										)
									) : (
										<Paper
											style={{
												backgroundColor: '#fff',
												boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px',
												borderRadius: '0 0px 8px 8px',
											}}
											attached="top"
										>
											<StatusBar
												first_time={this.state.first_time}
												key={'status-' + this.state.screen_ss}
												image_loaded={this.state.imageOnceLoaded}
												product={product}
												phone={this.state.selectedPhone}
											/>
											<PhonePreview
												screen_ss={this.state.screen_ss}
												imageOnLoad={this.imageOnLoad}
												selectedPhone={this.state.selectedPhone}
												imageLoad={this.state.imageLoad}
											/>
										</Paper>
									)
								)}
								{this.state.selectedPhone && product.settings.queue_booster && this.state.showingScreen === 'booster' && (
									<Paper
										style={{
											backgroundColor: '#fff',
											boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px',
											borderRadius: '0 0px 8px 8px',
											padding: '16px',
										}}
									>
										<div style={{ marginBottom: '12px', padding: '8px 12px', background: '#f3e8ff', borderRadius: '6px', fontSize: '12px', color: '#6b21a8' }}>
											<strong>Second Device QR</strong> — An additional connection that only listens to the message queue. Once the QR is scanned, it becomes active and processes outgoing messages in order.
										</div>
										{(() => {
											const phoneId = this.state.selectedPhone.id;
											const boosterStatus = this.state.boosterStatusMap[phoneId];
											const isLoading = boosterStatus === undefined || boosterStatus === null;
											const isActive = boosterStatus === 'active';
											const actionLoading = this.state.boosterActionLoading;
											if (isLoading) return <div style={{ textAlign: 'center', padding: 16 }}><Icon loading name="spinner" /> Checking...</div>;
											if (isActive) return (
												<div>
													<div style={{ position: 'relative', borderRadius: 4, overflow: 'hidden' }}>
														<img src="/mock_screen.png" alt="mock screen" style={{ width: '100%', display: 'block', opacity: 0.55 }} />
														<div style={{
															position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
															display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
															gap: 10,
														}}>
															<Icon name="rocket" size="huge" style={{ color: '#7b2ff7', margin: 0 }} />
															<div style={{ fontWeight: 'bold', fontSize: 18, color: '#fff', textShadow: '0 1px 4px rgba(0,0,0,0.7)' }}>
																Booster Active
															</div>
														</div>
													</div>
													<div style={{ background: '#f6f6f6', borderRadius: 8, padding: '10px 14px', fontSize: 12, color: '#555', lineHeight: 1.8, marginTop: 8 }}>
														<div>📱 Phone ID: <strong>{phoneId}</strong></div>
														<div>🔁 Mode: <strong>Queue only</strong></div>
														<div>✅ Status: <strong style={{ color: '#21ba45' }}>Connected</strong></div>
													</div>
													<div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
														<Button
															size="tiny"
															color="orange"
															loading={actionLoading === 'ba_logout'}
															disabled={!!actionLoading}
															onClick={() => this.callBoosterAction(phoneId, 'ba_logout')}
														>
															<Icon name="sign out" />
															Logout Second Device
														</Button>
														<Button
															size="tiny"
															color="red"
															loading={actionLoading === 'ba_clear'}
															disabled={!!actionLoading}
															onClick={() => this.callBoosterAction(phoneId, 'ba_clear')}
														>
															<Icon name="trash" />
															Clear Second Device Data
														</Button>
													</div>
												</div>
											);
											return (
												<div>
													<div style={{ height: '480px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
														{this.state.boosterQrError ? (
															<div style={{ textAlign: 'center', color: '#aaa', fontSize: 13 }}>
																<Icon name="exclamation circle" style={{ fontSize: 28, marginBottom: 8, display: 'block', color: '#e0a800' }} />
																<div style={{ marginBottom: 6 }}>QR could not be loaded.</div>
																<div style={{ fontSize: 12, color: '#bbb', marginBottom: 12 }}>
																	If the issue persists, try using <strong style={{ color: '#db2828' }}>Clear</strong> to reset the booster session.
																</div>
															</div>
														) : (
															<img
																src={`https://ty.maytapi.com/api/${product.settings.wapi_pid || product.id}/${phoneId}/ba_qrCode?token=${product.settings.wapi_token}&time=${this.state.boosterQrTs || ''}`}
																alt="Second Device QR"
																style={{ width: 240, height: 240 }}
																onError={() => this.setState({ boosterQrError: true })}
															/>
														)}
													</div>
													<div style={{ display: 'flex', gap: 8 }}>
														<Button
															size="tiny"
															color="red"
															loading={actionLoading === 'ba_clear'}
															disabled={!!actionLoading}
															onClick={() => this.callBoosterAction(phoneId, 'ba_clear')}
														>
															<Icon name="trash" />
															Clear Second Device Data
														</Button>
													</div>
												</div>
											);
										})()}
									</Paper>
								)}
								{!(this.state.selectedPhone && this.state.selectedPhone.bawa) &&
								((this.state.selectedPhone &&
									(
										(this.state.selectedPhone.qr_string || this.state.selectedPhone.newphone || this.state.selectedPhone.status === 'qr-screen') &&
										this.state.selectedPhone.status !== 'active'
									)) ||
									(this.state.selectedPhone && product.settings.queue_booster)) ? (
									<div style={{ marginTop: '10px' }}>
										<Button.Group>
											{this.state.selectedPhone.status !== 'active' && (
												<Button
													basic={this.state.showingScreen !== 'qrcode'}
													color="teal"
													active={this.state.showingScreen === 'qrcode'}
													onClick={() => this.setState({ showingScreen: 'qrcode' })}
												>
													QR-Code
												</Button>
											)}
											<Button
												basic={this.state.showingScreen !== 'screen'}
												color="teal"
												active={this.state.showingScreen === 'screen'}
												onClick={() =>
													this.state.showingScreen === 'screen' ? '' : this.setState({ showingScreen: 'screen', imageLoad: false })
												}
											>
												Screen
											</Button>
											{product.settings.queue_booster && !(this.state.selectedPhone && this.state.selectedPhone.bawa) && (
												<Button
													basic={this.state.showingScreen !== 'booster'}
													color="purple"
													active={this.state.showingScreen === 'booster'}
													onClick={() => this.setState({ showingScreen: 'booster' })}
												>
													Second Device QR
												</Button>
											)}
										</Button.Group>
									</div>
								) : null}

								{this.state.selectedPhone &&
									(this.state.selectedPhone.status === 'qr-screen' || this.state.selectedPhone.status === 'loading') &&
									this.state.selectedPhone.proxy === false &&
									this.state.showIndiaNotification === true && (
										<Alert
											severity="error"
											icon={
												<span className="pulsating-icon-wrapper" style={{ marginTop: '5px' }}>
													<span className="pulsating-icon">!</span>
												</span>
											}
											sx={{
												marginTop: '10px',
												textAlign: 'left',
												'& .pulsating-icon-wrapper': {
													display: 'inline-flex',
													justifyContent: 'center',
													alignItems: 'center',
													width: '24px',
													height: '24px',
													borderRadius: '50%',
													backgroundColor: 'error.main',
													animation: 'pulsate 1.2s ease-out infinite',
												},
												'& .pulsating-icon': {
													color: 'white',
													fontWeight: 'bold',
												},
												'@keyframes pulsate': {
													'0%': { transform: 'scale(0.9)' },
													'50%': { transform: 'scale(1.2)' },
													'100%': { transform: 'scale(0.9)' },
												},
											}}
										>
											You are currently connecting to Maytapi from the South Asia zone.{' '}
											<span style={{ fontWeight: '700' }}>(Phone ID : {this.state.selectedPhone.id})</span>
											<br />
											We recommend that you set the Mobile Proxy value to India to avoid any problems when connecting.
										</Alert>
									)}

								{this.state.selectedPhone &&
									(this.state.selectedPhone.status === 'qr-screen' || this.state.selectedPhone.status === 'loading') &&
									this.state.selectedPhone.proxy === false &&
									this.state.showSouthAmericaNotification === true && (
										<Alert
											severity="error"
											icon={
												<span className="pulsating-icon-wrapper" style={{ marginTop: '5px' }}>
													<span className="pulsating-icon">!</span>
												</span>
											}
											sx={{
												marginTop: '10px',
												textAlign: 'left',
												'& .pulsating-icon-wrapper': {
													display: 'inline-flex',
													justifyContent: 'center',
													alignItems: 'center',
													width: '24px',
													height: '24px',
													borderRadius: '50%',
													backgroundColor: 'error.main',
													animation: 'pulsate 1.2s ease-out infinite',
												},
												'& .pulsating-icon': {
													color: 'white',
													fontWeight: 'bold',
												},
												'@keyframes pulsate': {
													'0%': { transform: 'scale(0.9)' },
													'50%': { transform: 'scale(1.2)' },
													'100%': { transform: 'scale(0.9)' },
												},
											}}
										>
											You are currently connecting to Maytapi from the South America zone.{' '}
											<span style={{ fontWeight: '700' }}>(Phone ID : {this.state.selectedPhone.id})</span>
											<br />
											We recommend that you set the Mobile Proxy value to South America to avoid any problems when connecting.
										</Alert>
									)}
								{/** todo delete grid */}
								{this.state.selectedPhone && this.state.selectedPhone.status != 'active' && (
									<Paper
										spacing={2}
										sx={{
											marginBottom: '10px',
											backgroundColor: '#fff',
											boxShadow: 'rgb(131 131 131 / 65%) 0px 2px 8px 0px',
											textAlign: 'left',
										}}
										attached="top"
										color="green"
										textAlign="left"
									>
										<Alert sx={{ marginTop: '10px' }} severity="warning">
											If you can't access your instance currently and redeploy does not work you can use "Browser Stuck" to receive a
											fresh browser and re-scan qr-code.
											<Typography style={{ color: '#6363ff', cursor: 'pointer' }} onClick={() => this.setState({ stuckmodal: true })}>
												Browser Stuck
											</Typography>
										</Alert>
									</Paper>
								)}

								<div style={{ display: 'flex', textAlign: 'center', marginTop: '10px' }}>
									<Button positive as={Link} to="/developers/wp_postman_documentation" style={{ marginRight: '10px' }}>
										Go to Postman Collection
									</Button>
									<Button
										color="orange"
										onClick={() =>
											this.state.selectedPhone && this.state.selectedPhone.id
												? this.downloadJson()
												: this.setState({ opendocumentmodal: true })
										}
									>
										Download Postman Collection
									</Button>
								</div>
								{orderList.length ? (
									<Alert sx={{ marginTop: '10px', marginBottom: '10px', textAlign: 'left', alignItems: 'center' }} severity="info">
										<p>
											<b>Disable:</b> Disable your phone. (If you have enough limits, you can activate it later.)
										</p>
										<p>
											<b>Refresh: </b>Refresh your WhatsApp Screen.
										</p>
										<p>
											<b>Redeploy:</b> Restarts your WhatsApp instance.
										</p>
										<p>
											<b>Factory Reset:</b> Resets everything about phone instance to a new created instance state.
										</p>
										<p>
											<b>Browser Stuck:</b> Provides a clean browser instance, clears session, used when browser instance stuck and
											redeploy is not working.
										</p>
										<p>
											<b>Logout: </b>Logout from WhatsApp.
										</p>
									</Alert>
								) : null}
							</Grid>
						</Grid>
						<Alert sx={{ marginTop: '10px' }} severity="warning">
							We don't scan your old messages. We start to scan unread messages and messages that come after you scan QR code.
						</Alert>
						{getGeoLocation && getGeoLocation.country && getGeoLocation.country === 'IN' ? (
							<Snackbar
								open={showNotification}
								anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
								autoHideDuration={30000}
								onClose={this.handleCloseNotification}
							>
								<Alert severity="info" action={<Icon name="close" style={{ margin: 0 }} onClick={this.handleCloseNotification}></Icon>}>
									If you are trying to connect from India and cannot connect, please click on the 'Mobile Proxy' button found in the right
									panel.
									<br />
									Note:The Mobile Proxy button will appear if the QR screen is displayed on your phone.
								</Alert>
							</Snackbar>
						) : (
							<>
								<Snackbar
									open={showNotification}
									anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
									autoHideDuration={30000}
									onClose={this.handleCloseNotification}
								>
									<Alert severity="info" action={<Icon name="close" style={{ margin: 0 }} onClick={this.handleCloseNotification}></Icon>}>
										If you have scanned the QR code and still cannot connect, please contact us.
										<br />
										info@maytapi.com
									</Alert>
								</Snackbar>
							</>
						)}
						{/* <Alert sx={{ marginTop: '10px' }} severity="error">
							If you want to take the history of all old chats on WhatsApp. <Link to="/contact">Please contact us.</Link>
						</Alert> */}
					</Page.Wrap>
					<Modal open={this.state.deleteBtnClicked} onClose={this.closeDeleteButton}>
						<Header icon="dont" content="Disable the Selected Phone" />
						<Modal.Content>
							<p>Are you sure you want to disable the phone?</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> No
							</Button>
							<Button color="green" onClick={this.handleDelete}>
								<Icon name="checkmark" /> Yes
							</Button>
						</Modal.Actions>
					</Modal>
					{/*go to subs modal*/}
					<Modal open={this.state.goToSubs} onClose={this.closeDeleteButton}>
						<Header icon="mobile alternate" content="Phone Limit" />
						<Modal.Content>
							<p>Your phone limit is not enough for add new phone.</p>
							<p>Do you want to update phone subscription.</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> No
							</Button>
							<Button color="green" as={Link} to="/subscription">
								<Icon name="checkmark" /> Yes
							</Button>
							<p>If want to change phone number, you can logout from one phone id.</p>
						</Modal.Actions>
					</Modal>
					{/*disabled modal*/}
					<Modal open={this.state.disabledModal} onClose={this.closeDeleteButton}>
						<Header icon="dont" content="Enabled Error" />
						<Modal.Content>
							<p>{this.state.disabledModalMessage}</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="green" as={Link} to="/subscription">
								Go to Subscription
							</Button>
						</Modal.Actions>
					</Modal>
					<PhoneSubscriptionUpdateModal
						open={this.state.subscriptionUpdateModalOpen}
						onClose={this.closeSubscriptionUpdateModal}
						currentPhones={this.state.currentPhones}
						totalPhones={this.state.totalPhones}
						product={this.props.product}
						account_phone_price={this.props.product.settings.phone25 ? 25 : 29}
						onSuccess={this.refreshSubscription}
						onMessageUpdate={this.handleMessageUpdate}
						showPreview={!this.state.quickUpdateMode}
					/>
					{/*redeploy modal*/}
					<Modal open={this.state.openRedeploy} onClose={this.closeDeleteButton}>
						<Header icon="redo" content="Redeploy Phone" />
						<Modal.Content>
							<p>Are you sure redeploy to phone?</p>
							<p>This action opens a new session for your phone. (It's not a refresh screen)</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								Close
							</Button>
							<Button color="green" onClick={this.redeployPhone}>
								Redeploy
							</Button>
						</Modal.Actions>
					</Modal>
					{/*connect with phone number modal*/}
					<Modal open={this.state.openConnectWithPhoneNumber} onClose={this.closeDeleteButton}>
						<Header icon="whatsapp" content="Connect With Phone Number" />
						<Modal.Content>
							<strong style={{ fontWeight: 600 }}>This process may take some time</strong>
							<ul style={{ marginTop: '5px' }}>
								<li>After pressing the "Connect" button, it may take a while to get the code.</li>
								<li>Enter the phone number you want to connect with this instance: {this.state.connectNumber}</li>
								<li>Please enter your number with the country code.</li>
							</ul>
							<TextField
								id="number"
								label="Number"
								type="number"
								required
								onChange={(e) => this.setState({ phoneNumber: e.target.value })}
								InputLabelProps={{
									shrink: true,
								}}
								placeholder="901234567890"
							/>
							{_.map(phones, (it) => {
								let __phoneId = it.id;
								let __selectedPhoneId = this.state.selectedPhone && this.state.selectedPhone.id;
								if (__phoneId === __selectedPhoneId) {
									return (
										it &&
										it.connectionResult && (
											<Linkk
												style={{ marginLeft: '20px', marginTop: '15px' }}
												component="button"
												variant="body2"
												onClick={this.connectWithPhoneNumber}
												disabled={!this.state.phoneNumber}
											>
												Take Code Again
											</Linkk>
										)
									);
								}
							})}
							<br />
							{this.state.codeConnecting && (
								<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									<CircularProgress />
								</Box>
							)}
							{!this.state.codeConnecting &&
								_.map(phones, (it) => {
									let __phoneId = it.id;
									let __selectedPhoneId = this.state.selectedPhone && this.state.selectedPhone.id;
									if (__phoneId === __selectedPhoneId) {
										if (it && it.connectionResult)
											return (
												<>
													<div style={{ width: '100%', textAlign: 'center', fontSize: '25px' }}>
														Your Connect Code: {it.connectionResult}
														<div style={{ width: '100%', textAlign: 'left', fontSize: '14px' }}>
															1. Open WhatsApp in Your Phone.
															<br />
															2. Settings - Linked Devices - Link Device(Blue Button) - "Link with phone number instead" written
															at the bottom
															<br />
															3. Enter your code
															<br />
															<div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}></div>
															<Grid container spacing={3}>
																<Grid item xs={6} sm={3}>
																	<Item>
																		<img
																			src="https://cdnydm.com/permedia/i9d8XMx8VRTw2gHvozjRAA.jpg?size=1170x2532"
																			style={{ maxWidth: '100%', height: '400px' }}
																		/>
																	</Item>
																</Grid>
																<Grid item xs={6} sm={3}>
																	<Item>
																		<img
																			src="https://cdnydm.com/permedia/j-BxqN1etSLk7rK6IR6SrQ.jpg?size=739x1600"
																			style={{ maxWidth: '100%', height: '400px' }}
																		/>
																	</Item>
																</Grid>
																<Grid item xs={6} sm={3}>
																	<Item>
																		<img
																			src="https://cdnydm.com/permedia/tB4xRxHpLcRh5dROyyFWaA.jpg?size=739x1600"
																			style={{ maxWidth: '100%', height: '400px' }}
																		/>
																	</Item>
																</Grid>
																<Grid item xs={6} sm={3}>
																	<Item>
																		<img
																			src="https://cdnydm.com/permedia/IITzG2OXOdokRf9Hj93uqg.jpg?size=1170x2532"
																			style={{ maxWidth: '100%', height: '400px' }}
																		/>
																	</Item>
																</Grid>
															</Grid>
														</div>
													</div>
												</>
											);
									}
								})}
						</Modal.Content>
						{_.map(phones, (it) => {
							let __phoneId = it.id;
							let __selectedPhoneId = this.state.selectedPhone && this.state.selectedPhone.id;

							if (__phoneId === __selectedPhoneId) {
								return (
									<Modal.Actions>
										<Button color="red" onClick={this.closeDeleteButton}>
											Close
										</Button>
										{it && !it.connectionResult && (
											<Button
												color="green"
												onClick={this.connectWithPhoneNumber}
												disabled={!this.state.phoneNumber || this.state.connecting}
											>
												Connect
											</Button>
										)}
									</Modal.Actions>
								);
							}
						})}
						{/* <Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								Close
							</Button>
							{!this.state.connectCode && (
								<Button color="green" onClick={this.connectWithPhoneNumber} disabled={!this.state.phoneNumber || this.state.connecting}>
									Connect
								</Button>
							)}
						</Modal.Actions> */}
					</Modal>
					{/*factoryreset modal*/}
					<Modal open={this.state.logoutModal} onClose={this.closeDeleteButton}>
						<Header icon="warning" content="Logout" />
						<Modal.Content>
							<p>Are you sure you want to logout?</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={() => this.setState({ logoutModal: false })}>
								<Icon name="close" /> No
							</Button>
							<Button color="green" onClick={this.logoutPhone}>
								<Icon name="checkmark" /> Yes
							</Button>
						</Modal.Actions>
					</Modal>
					<Modal open={this.state.factoryresetmodal} onClose={this.closeDeleteButton}>
						<Header icon="dont" content="Factory Reset" />

						<Modal.Content>
							<p>Are you sure you want to factory reset?</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> No
							</Button>
							<Button color="green" onClick={this.factoryResetPhone}>
								<Icon name="checkmark" /> Yes
							</Button>
						</Modal.Actions>
					</Modal>
					{/*stuck modal*/}
					<Modal open={this.state.stuckmodal} onClose={this.closeDeleteButton}>
						<Header icon="question" content="Browser Stuck" />

						<Modal.Content>
							<p>We can swap your browser with clean state, but you need to rescan qr-code!</p>
							<p>Would you like to clear your browser?</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> No
							</Button>
							<Button color="green" onClick={this.StuckClearPhone}>
								<Icon name="checkmark" /> Yes
							</Button>
						</Modal.Actions>
					</Modal>
					{/*redeploy to all phone modal*/}
					<Modal open={this.state.redeployallmodal} onClose={this.closeDeleteButton}>
						<Header icon="question" content="Redeploy to selected phones" />

						<Modal.Content>
							<p>This will redeploy your selected phones.</p>
							<p>The redeployment process will start for these phones, and the duration may vary depending on the number of phones.</p>
							<p>Are you sure you want to do this?</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> No
							</Button>
							<Button color="green" onClick={this.redeployToSelected}>
								<Icon name="checkmark" /> Yes
							</Button>
						</Modal.Actions>
					</Modal>
					{/*no phone document modal*/}
					<Modal open={this.state.opendocumentmodal} onClose={this.closeDeleteButton}>
						<Header icon="file" content="Document" />
						<Modal.Content>
							<p>You must have at least one phone id for using Maytapi Documents.</p>
							<p>Are you sure download without phone id?</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> No
							</Button>
							<Button color="orange" onClick={() => this.downloadJson()}>
								<Icon name="checkmark" /> Download Postman Collection
							</Button>
						</Modal.Actions>
					</Modal>
					{/*edit modal */}
					<Modal open={this.state.openeditmodal} onClose={this.closeDeleteButton} style={{ maxWidth: '50vh' }}>
						<Header icon="edit" content="Change Name" />
						<Modal.Content>
							<Input name="phone_name" value={phone_name} onChange={this.handleChange} style={{ maxWidth: '170px' }}>
								<Label className="only-web" style={{ display: 'flex', alignItems: 'center' }}>
									{'Name'}
								</Label>
								<input maxLength={20} />{' '}
							</Input>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeDeleteButton}>
								<Icon name="remove" /> Back
							</Button>
							<Button color="green" onClick={() => this.setName()}>
								<Icon name="checkmark" /> Save
							</Button>
						</Modal.Actions>
					</Modal>
					{/*Send Test Message Modal */}{' '}
					{this.state.openmodal && (
						<Modal id="testMessageModal" open={this.state.openmodal} onClose={() => this.setState({ openmodal: false })}>
							<Modal.Header>Send Test Message</Modal.Header>
							<Modal.Actions>
								{' '}
								<FormControl sx={{ width: '100%' }}>
									<InputLabel id="demo-simple-select-label" sx={{ textAlign: 'left' }}>
										Phones
									</InputLabel>
									<Select
										sx={{ textAlign: 'left' }}
										labelId="testphoneid"
										id="testphoneid"
										value={this.state.testphoneid}
										margin="normal"
										fullWidth
										defaultValue={'Select Phone'}
										placeholder={'Select Phone'}
										label={'Select Phone'}
										name="testphoneid"
										onChange={this.handleCheckPhoneStatus}
									>
										{this.state.phones.map((items) => {
											return <MenuItem value={items.id}>{items.id}</MenuItem>;
										})}
									</Select>
								</FormControl>
								{this.state.statusmsg && (
									<Alert severity="error" sx={{ textAlign: 'left', margin: '10px 0 10px 0 ' }}>
										{this.state.statusmsg}
									</Alert>
								)}
								<TextField
									id="testnumber"
									name="testnumber"
									fullWidth
									margin="normal"
									required
									label="Test Number"
									value={this.state.testnumber}
									onChange={this.handleChangeWebhook}
								/>
								<TextField
									id="testmessage"
									name="testmessage"
									fullWidth
									margin="normal"
									required
									label="Text Message"
									value={this.state.testmessage}
									onChange={this.handleChangeWebhook}
								/>
								{this.state.error && (
									<Alert severity="error" sx={{ marginBottom: '10px' }}>
										{this.state.error}
									</Alert>
								)}
								{this.state.error && (
									<CopyToClipboard text={this.state.getCUrl}>
										<Button icon size="tiny" color="teal" onClick={() => this.clickCopyCurl()}>
											<Icon name="copy" style={{ margin: 0 }}></Icon>
											{this.state.cpyCurl}
										</Button>
									</CopyToClipboard>
								)}
								{this.state.success && (
									<>
										<Alert severity="success" margin="normal" style={{ marginBottom: '10px' }} sx={{ textAlign: 'left' }}>
											{this.state.success} Look at <NavLink to="/developers/logs">Logs</NavLink> whether test message is sent or not and
											refresh at logs whether.
										</Alert>{' '}
									</>
								)}
								{this.state.success && (
									<CopyToClipboard text={this.state.getCUrl}>
										<Button icon size="tiny" color="teal" onClick={() => this.clickCopyCurl()}>
											<Icon name="copy" style={{ margin: 0 }}></Icon>
											{this.state.cpyCurl}
										</Button>
									</CopyToClipboard>
								)}
							</Modal.Actions>
							<Modal.Actions>
								<Button color="red" onClick={this.setDefaultStates}>
									Back
								</Button>

								<Button
									style={{
										background: '#21ba45',
										color: 'white',
										marginRight: '10px',
										':hover': {
											backgroundColor: '#1b9f3a',
										},
									}}
									disabled={this.state.disabledbtn}
									loading={this.state.loadbtn}
									onClick={this.handleCheckWebhook}
								>
									Send
								</Button>
							</Modal.Actions>
						</Modal>
					)}
					<Modal open={this.state.sandboxModalOpen} onClose={this.closeSandboxModal}>
						<Header icon="phone" content="WhatsApp Sandbox Phone - API" />
						<Modal.Content>
							<h4>Develop and test your WhatsApp integration for free!</h4>
							<h4>Features:</h4>
							<ul>
								<li>Full WhatsApp API functionality</li>
								<li>Use your own phone number</li>
								<li>Real WhatsApp infrastructure</li>
							</ul>
							<h4>Usage Limits:</h4>
							<ul>
								<li>5 conversations/month</li>
								<li>150 messages/day</li>
								<li>Limited account checks & API calls</li>
							</ul>
							<p>
								<strong>No cost, no commitment required.</strong>
							</p>
						</Modal.Content>
						<Modal.Actions>
							<Button color="red" onClick={this.closeSandboxModal}>
								<Icon name="remove" /> No
							</Button>
							<Button color="green" onClick={this.handleConfirmSandbox}>
								<Icon name="checkmark" /> Yes
							</Button>
						</Modal.Actions>
					</Modal>
					<Modal
						open={this.state.passkeyHelpModalOpen}
						onClose={() => this.setState({ passkeyHelpModalOpen: false })}
						closeIcon
					>
						<Header icon="key" content="Having a passkey issue? Connect via the browser extension" />
						<Modal.Content scrolling>
							<h4>Why this happens</h4>
							<p>
								WhatsApp recently introduced passkey verification for accounts. A passkey is a security key generated by your
								device's platform authenticator (for example iCloud Keychain or Samsung Pass) and, by design, it cannot be
								exported. Because this verification is enforced on the server side, an account with an active passkey cannot be
								connected to our system using the standard QR-scan method.
							</p>

							<h4>The solution</h4>
							<p>
								To solve this, we built a browser extension. The extension lets you connect your account directly through <strong>web.whatsapp.com</strong> and securely transfer your session information into our system. This way you can use passkey-protected accounts without any issues.
								<strong>web.whatsapp.com</strong> and securely transfer your session information into our system. This way you
								can use passkey-protected accounts without any issues.
							</p>

							<h4>Connection steps</h4>
							<ol style={{ lineHeight: 1.7, paddingLeft: '20px' }}>
								<li>
									Make sure the account you want to connect is <strong>not already linked</strong> to another web.whatsapp.com
									session. If it is, unlink it first.
								</li>
								<li>
									Log in to{' '}
									<a href="https://console.maytapi.com" target="_blank" rel="noopener noreferrer">
										https://console.maytapi.com
									</a>
									.
								</li>
								<li>
									Click the orange key icon (<Icon name="key" color="orange" style={{ margin: 0 }} />) next to the instance you
									want to connect. This will redirect you to web.whatsapp.com. If you don't see the orange key button yet, click
									the <strong>"Use passkey extension"</strong> button below to enable it.
								</li>
								<li>
									On the web.whatsapp.com screen, scan the account you couldn't connect with the normal method. If the correct
									account appears, keep it; otherwise unlink it and scan a fresh QR code.
								</li>
								<li>
									Once the scan is complete, click the <strong>Export</strong> button in the extension box. A "success" message
									will appear.
								</li>
								<li>
									When you see the success message, close the tab and go back to console.maytapi.com. Click the instance you
									just processed and check its status on the right — it will be connected without any further redirect.
								</li>
							</ol>

							<Divider />

							<h4>Installing the extension (Session Exporter)</h4>
							<p>
								We provide the extension as a ZIP file. First download it, then follow the steps below:
							</p>
							<p>
								<Button
									as="a"
									href={process.env.PUBLIC_URL + '/passkey_extension.zip'}
									download
									color="orange"
									size="small"
								>
									<Icon name="download" /> Download extension (ZIP)
								</Button>
							</p>
							<ol style={{ lineHeight: 1.7, paddingLeft: '20px' }}>
								<li>Extract the ZIP file.</li>
								<li>
									Open <code>chrome://extensions/</code> in your browser.
								</li>
								<li>
									Enable <strong>Developer mode</strong> (top-right), then click <strong>Load unpacked</strong>.
								</li>
								<li>
									Select the extracted <code>passkey_extension</code> folder.
								</li>
								<li>
									The extension (<strong>Session Exporter</strong>) will be installed and ready to use.
								</li>
							</ol>
						</Modal.Content>
						<Modal.Actions>
							<Button color="grey" onClick={() => this.setState({ passkeyHelpModalOpen: false })}>
								<Icon name="remove" /> Close
							</Button>
							{product.settings.use_passkey_extension ? (
								<Button color="green" disabled>
									<Icon name="check" /> Passkey extension enabled
								</Button>
							) : (
								<Button
									color="orange"
									loading={this.state.enablingPasskeyExtension}
									disabled={this.state.enablingPasskeyExtension}
									onClick={this.enablePasskeyExtension}
								>
									<Icon name="key" /> Use passkey extension
								</Button>
							)}
						</Modal.Actions>
					</Modal>
				</Page>
			);
		}
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.maytapi,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(Phones);
